(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';
window.Backbone = require('backbone');

Backbone.$ = window.$;

require('../../modules/home/frontend/main');

require('../../node_modules/widget-layout-assets/coffee/wls');



},{"../../modules/home/frontend/main":3,"../../node_modules/widget-layout-assets/coffee/wls":13,"backbone":9}],2:[function(require,module,exports){
module.exports = {
  product_reviews: require('../product_reviews/main.html.mustache')
};



},{"../product_reviews/main.html.mustache":8}],3:[function(require,module,exports){
var LeftNav, PartialRenderer, ProductReviews;

LeftNav = require('../../left_nav/frontend/main');

ProductReviews = require('../../product_reviews/frontend/main');

PartialRenderer = require('./partial_renderer');

$(window).load(function() {
  var payload;
  Groupon.Performance.pageReady();
  payload = Groupon.Utils.getConfigFromDom();
  new LeftNav();
  new PartialRenderer(payload);
  return new ProductReviews(payload);
});



},{"../../left_nav/frontend/main":5,"../../product_reviews/frontend/main":6,"./partial_renderer":4}],4:[function(require,module,exports){
var PartialRenderer, ProductReviews,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

ProductReviews = require('../../product_reviews/frontend/main');

module.exports = PartialRenderer = (function() {
  function PartialRenderer(payload) {
    this.payload = payload;
    this.fetchAlways = bind(this.fetchAlways, this);
    this.fetchDone = bind(this.fetchDone, this);
    this.$partialRenderingLoader = $('#partial-rendering-loader');
    if (!this.$partialRenderingLoader.length) {
      return;
    }
    $.get('goods/widgets').done(this.fetchDone).always(this.fetchAlways);
  }

  PartialRenderer.prototype.fetchDone = function(html) {
    var $widgets;
    if (!html.length) {
      return;
    }
    $widgets = $.parseHTML(html);
    this.$partialRenderingLoader.after($widgets);
    return $('.lazy-load', $widgets).lazyload({
      threshold: 200
    });
  };

  PartialRenderer.prototype.fetchAlways = function() {
    this.$partialRenderingLoader.hide();
    return new ProductReviews(this.payload);
  };

  return PartialRenderer;

})();



},{"../../product_reviews/frontend/main":6}],5:[function(require,module,exports){
var LeftNav;

module.exports = LeftNav = (function() {
  function LeftNav() {
    var ref, ref1;
    this.$nav = $('#left-nav-categories');
    this.$navUl = (ref = this.$nav) != null ? ref.find('> ul') : void 0;
    this.$navList = (ref1 = this.$navUl) != null ? ref1.children() : void 0;
    if (!this.$navList.length) {
      return;
    }
    this.navHeight = this.$nav.outerHeight();
    this.navPadding = this.$navUl.position().top;
    this.arrowTop = parseInt($(this.$navList.find('.arrow')[0]).css('top'));
    this.displacementCache = [];
    this.setSubNavPosition();
    this.enableSuvNav();
  }

  LeftNav.prototype.setSubNavPosition = function() {
    var $flyout, $nav, displacement, i, len, nav, ref, results;
    ref = this.$navList;
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      nav = ref[i];
      $nav = $(nav);
      $flyout = $nav.find('.left-nav-flyout');
      if (!$flyout) {
        continue;
      }
      if (!(this.subnavHeight && this.subnavPadding)) {
        $flyout.css({
          display: 'block',
          visibility: 'hidden'
        });
        this.subnavHeight = $($flyout.find('li')[0]).outerHeight(true);
        $flyout.removeAttr('style');
      }
      displacement = this.calculateDisplacement({
        top: $nav.position().top,
        height: $flyout.outerHeight(),
        arrowPosition: Math.floor(($flyout.find('ul:first').children().length) / 2) || 1
      });
      results.push(this.applyDisplacement($flyout, displacement));
    }
    return results;
  };

  LeftNav.prototype.calculateDisplacement = function(arg) {
    var arrowPosition, displacement, height, top;
    top = arg.top, height = arg.height, arrowPosition = arg.arrowPosition;
    displacement = this.displacementCache[arrowPosition];
    if (!displacement) {
      displacement = (this.subnavHeight - this.arrowTop) * (1 - arrowPosition) - this.arrowTop / 2;
      this.displacementCache[arrowPosition] = displacement;
    }
    if (top + displacement < this.navPadding) {
      return this.navPadding - top;
    }
    if (top + displacement + height > this.navHeight - this.navPadding) {
      return this.navHeight - this.navPadding - top - height;
    }
    return displacement;
  };

  LeftNav.prototype.applyDisplacement = function($flyout, displacement) {
    $flyout.css('top', displacement + "px");
    return $flyout.find('.arrow').css('top', ((displacement * -1) + this.arrowTop) + "px");
  };

  LeftNav.prototype.enableSuvNav = function() {
    return this.$nav.removeClass('flyout-disabled');
  };

  return LeftNav;

})();



},{}],6:[function(require,module,exports){
var ProductReviews, Review,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

Review = require('./review');

module.exports = ProductReviews = (function() {
  function ProductReviews(arg) {
    var productReviews;
    productReviews = arg.productReviews;
    this.fetchSuccess = bind(this.fetchSuccess, this);
    if ($('#partial-rendering-loader').is(':visible')) {
      return;
    }
    if (productReviews) {
      this.rootUrl = productReviews.rootUrl, this.locale = productReviews.locale;
    }
    if (!(this.rootUrl && this.locale)) {
      return;
    }
    this.fetchProductReviews();
  }

  ProductReviews.prototype.fetchProductReviews = function() {
    var csrf;
    this.deals = $('figure.deal-card[data-uuid], figure.deal-card-mini[data-uuid], .carousel-slide-deal[data-uuid]');
    if (this.deals.length) {
      csrf = $('meta[name=csrf-token]').attr('content');
      return $.ajax({
        url: this.rootUrl + "/product_review_proxy/products.json?locale=" + this.locale + "&_csrf=" + csrf,
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(this.prepareData()),
        error: this.fetchError,
        success: this.fetchSuccess
      });
    }
  };

  ProductReviews.prototype.prepareData = function() {
    return {
      deal_uuid: this.extractDealUuids().join()
    };
  };

  ProductReviews.prototype.extractDealUuids = function() {
    var dealUuids;
    dealUuids = [];
    this.deals.each(function() {
      var uuid;
      uuid = $(this).data('uuid');
      if (uuid.length) {
        return dealUuids.push(uuid);
      }
    });
    return dealUuids;
  };

  ProductReviews.prototype.fetchError = function() {};

  ProductReviews.prototype.fetchSuccess = function(data) {
    var products;
    if (!(products = data.products)) {
      return;
    }
    return this.deals.each(function() {
      var $el, params, uuid;
      $el = $(this);
      uuid = $el.data('uuid');
      params = {
        $el: $el,
        data: products[uuid],
        uuid: uuid
      };
      if (params.data) {
        return (new Review(params)).render();
      }
    });
  };

  return ProductReviews;

})();



},{"./review":7}],7:[function(require,module,exports){
var Review, templates;

templates = require('../../client-templates');

module.exports = Review = (function() {
  function Review(arg) {
    this.data = arg.data, this.uuid = arg.uuid, this.$el = arg.$el;
  }

  Review.prototype.prepareData = function() {
    var bhc, i, position, rating, ref, starType, stars;
    if (!(((ref = this.data) != null ? ref.averageRating : void 0) && this.data.ratingCount)) {
      return;
    }
    rating = Math.round(this.data.averageRating * 10) / 10;
    bhc = {
      rating: "review-rating:" + this.uuid + "_" + rating,
      ratingCount: "rating-count:" + this.uuid + "_" + this.data.ratingCount
    };
    stars = [];
    for (position = i = 1; i <= 5; position = ++i) {
      starType = (function() {
        switch (false) {
          case !(rating > 3 / 4):
            return 'full-star';
          case !(rating > 1 / 4):
            return 'half-star';
          default:
            return 'empty-star';
        }
      })();
      stars.push("<span class='" + starType + "'></span>");
      rating--;
    }
    return {
      productRating: {
        bhc: bhc,
        count: I18n.toNumber(this.data.ratingCount),
        stars: stars
      }
    };
  };

  Review.prototype.render = function() {
    return this.$el.find('.deal-title').after(templates.product_reviews.render(this.prepareData()));
  };

  return Review;

})();



},{"../../client-templates":2}],8:[function(require,module,exports){
var Hogan = require('hogan.js');
module.exports = new Hogan.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"deal-product-review\">");t.b("\n" + i);if(t.s(t.f("productRating",c,p,1),c,p,0,56,271,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("    <ul class=\"rating\" data-bhc=\"");t.b(t.v(t.d("bhc.rating",c,p,0)));t.b("\">");t.b("\n" + i);if(t.s(t.f("stars",c,p,1),c,p,0,127,161,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("        <li>");t.b(t.t(t.d(".",c,p,0)));t.b("</li>");t.b("\n" + i);});c.pop();}t.b("    </ul>");t.b("\n" + i);t.b("    <span class=\"rating-count\" data-bhc=\"");t.b(t.v(t.d("bhc.ratingCount",c,p,0)));t.b("\">(");t.b(t.v(t.f("count",c,p,0)));t.b(")</span>");t.b("\n" + i);});c.pop();}t.b("</div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"deal-product-review\">\n  {{# productRating }}\n    <ul class=\"rating\" data-bhc=\"{{ bhc.rating }}\">\n      {{# stars }}\n        <li>{{{ . }}}</li>\n      {{/ stars }}\n    </ul>\n    <span class=\"rating-count\" data-bhc=\"{{ bhc.ratingCount }}\">({{ count }})</span>\n  {{/ productRating }}\n</div>\n", Hogan);
},{"hogan.js":11}],9:[function(require,module,exports){
(function (global){
//     Backbone.js 1.0.0

//     (c) 2010-2013 Jeremy Ashkenas, DocumentCloud Inc.
//     Backbone may be freely distributed under the MIT license.
//     For all details and documentation:
//     http://backbonejs.org

(function(){

  // Initial Setup
  // -------------

  // Save a reference to the global object (`window` in the browser, `exports`
  // on the server).
  var root = this;

  // Save the previous value of the `Backbone` variable, so that it can be
  // restored later on, if `noConflict` is used.
  var previousBackbone = root.Backbone;

  // Create local references to array methods we'll want to use later.
  var array = [];
  var push = array.push;
  var slice = array.slice;
  var splice = array.splice;

  // The top-level namespace. All public Backbone classes and modules will
  // be attached to this. Exported for both the browser and the server.
  var Backbone;
  if (typeof exports !== 'undefined') {
    Backbone = exports;
  } else {
    Backbone = root.Backbone = {};
  }

  // Current version of the library. Keep in sync with `package.json`.
  Backbone.VERSION = '1.0.0';

  // Require Underscore, if we're on the server, and it's not already present.
  var _ = root._;
  if (!_ && (typeof require !== 'undefined')) _ = (typeof window !== "undefined" ? window['_'] : typeof global !== "undefined" ? global['_'] : null);

  // For Backbone's purposes, jQuery, Zepto, Ender, or My Library (kidding) owns
  // the `$` variable.
  Backbone.$ = root.jQuery || root.Zepto || root.ender || root.$;

  // Runs Backbone.js in *noConflict* mode, returning the `Backbone` variable
  // to its previous owner. Returns a reference to this Backbone object.
  Backbone.noConflict = function() {
    root.Backbone = previousBackbone;
    return this;
  };

  // Turn on `emulateHTTP` to support legacy HTTP servers. Setting this option
  // will fake `"PUT"` and `"DELETE"` requests via the `_method` parameter and
  // set a `X-Http-Method-Override` header.
  Backbone.emulateHTTP = false;

  // Turn on `emulateJSON` to support legacy servers that can't deal with direct
  // `application/json` requests ... will encode the body as
  // `application/x-www-form-urlencoded` instead and will send the model in a
  // form param named `model`.
  Backbone.emulateJSON = false;

  // Backbone.Events
  // ---------------

  // A module that can be mixed in to *any object* in order to provide it with
  // custom events. You may bind with `on` or remove with `off` callback
  // functions to an event; `trigger`-ing an event fires all callbacks in
  // succession.
  //
  //     var object = {};
  //     _.extend(object, Backbone.Events);
  //     object.on('expand', function(){ alert('expanded'); });
  //     object.trigger('expand');
  //
  var Events = Backbone.Events = {

    // Bind an event to a `callback` function. Passing `"all"` will bind
    // the callback to all events fired.
    on: function(name, callback, context) {
      if (!eventsApi(this, 'on', name, [callback, context]) || !callback) return this;
      this._events || (this._events = {});
      var events = this._events[name] || (this._events[name] = []);
      events.push({callback: callback, context: context, ctx: context || this});
      return this;
    },

    // Bind an event to only be triggered a single time. After the first time
    // the callback is invoked, it will be removed.
    once: function(name, callback, context) {
      if (!eventsApi(this, 'once', name, [callback, context]) || !callback) return this;
      var self = this;
      var once = _.once(function() {
        self.off(name, once);
        callback.apply(this, arguments);
      });
      once._callback = callback;
      return this.on(name, once, context);
    },

    // Remove one or many callbacks. If `context` is null, removes all
    // callbacks with that function. If `callback` is null, removes all
    // callbacks for the event. If `name` is null, removes all bound
    // callbacks for all events.
    off: function(name, callback, context) {
      var retain, ev, events, names, i, l, j, k;
      if (!this._events || !eventsApi(this, 'off', name, [callback, context])) return this;
      if (!name && !callback && !context) {
        this._events = {};
        return this;
      }

      names = name ? [name] : _.keys(this._events);
      for (i = 0, l = names.length; i < l; i++) {
        name = names[i];
        if (events = this._events[name]) {
          this._events[name] = retain = [];
          if (callback || context) {
            for (j = 0, k = events.length; j < k; j++) {
              ev = events[j];
              if ((callback && callback !== ev.callback && callback !== ev.callback._callback) ||
                  (context && context !== ev.context)) {
                retain.push(ev);
              }
            }
          }
          if (!retain.length) delete this._events[name];
        }
      }

      return this;
    },

    // Trigger one or many events, firing all bound callbacks. Callbacks are
    // passed the same arguments as `trigger` is, apart from the event name
    // (unless you're listening on `"all"`, which will cause your callback to
    // receive the true name of the event as the first argument).
    trigger: function(name) {
      if (!this._events) return this;
      var args = slice.call(arguments, 1);
      if (!eventsApi(this, 'trigger', name, args)) return this;
      var events = this._events[name];
      var allEvents = this._events.all;
      if (events) triggerEvents(events, args);
      if (allEvents) triggerEvents(allEvents, arguments);
      return this;
    },

    // Tell this object to stop listening to either specific events ... or
    // to every object it's currently listening to.
    stopListening: function(obj, name, callback) {
      var listeners = this._listeners;
      if (!listeners) return this;
      var deleteListener = !name && !callback;
      if (typeof name === 'object') callback = this;
      if (obj) (listeners = {})[obj._listenerId] = obj;
      for (var id in listeners) {
        listeners[id].off(name, callback, this);
        if (deleteListener) delete this._listeners[id];
      }
      return this;
    }

  };

  // Regular expression used to split event strings.
  var eventSplitter = /\s+/;

  // Implement fancy features of the Events API such as multiple event
  // names `"change blur"` and jQuery-style event maps `{change: action}`
  // in terms of the existing API.
  var eventsApi = function(obj, action, name, rest) {
    if (!name) return true;

    // Handle event maps.
    if (typeof name === 'object') {
      for (var key in name) {
        obj[action].apply(obj, [key, name[key]].concat(rest));
      }
      return false;
    }

    // Handle space separated event names.
    if (eventSplitter.test(name)) {
      var names = name.split(eventSplitter);
      for (var i = 0, l = names.length; i < l; i++) {
        obj[action].apply(obj, [names[i]].concat(rest));
      }
      return false;
    }

    return true;
  };

  // A difficult-to-believe, but optimized internal dispatch function for
  // triggering events. Tries to keep the usual cases speedy (most internal
  // Backbone events have 3 arguments).
  var triggerEvents = function(events, args) {
    var ev, i = -1, l = events.length, a1 = args[0], a2 = args[1], a3 = args[2];
    switch (args.length) {
      case 0: while (++i < l) (ev = events[i]).callback.call(ev.ctx); return;
      case 1: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1); return;
      case 2: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2); return;
      case 3: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2, a3); return;
      default: while (++i < l) (ev = events[i]).callback.apply(ev.ctx, args);
    }
  };

  var listenMethods = {listenTo: 'on', listenToOnce: 'once'};

  // Inversion-of-control versions of `on` and `once`. Tell *this* object to
  // listen to an event in another object ... keeping track of what it's
  // listening to.
  _.each(listenMethods, function(implementation, method) {
    Events[method] = function(obj, name, callback) {
      var listeners = this._listeners || (this._listeners = {});
      var id = obj._listenerId || (obj._listenerId = _.uniqueId('l'));
      listeners[id] = obj;
      if (typeof name === 'object') callback = this;
      obj[implementation](name, callback, this);
      return this;
    };
  });

  // Aliases for backwards compatibility.
  Events.bind   = Events.on;
  Events.unbind = Events.off;

  // Allow the `Backbone` object to serve as a global event bus, for folks who
  // want global "pubsub" in a convenient place.
  _.extend(Backbone, Events);

  // Backbone.Model
  // --------------

  // Backbone **Models** are the basic data object in the framework --
  // frequently representing a row in a table in a database on your server.
  // A discrete chunk of data and a bunch of useful, related methods for
  // performing computations and transformations on that data.

  // Create a new model with the specified attributes. A client id (`cid`)
  // is automatically generated and assigned for you.
  var Model = Backbone.Model = function(attributes, options) {
    var defaults;
    var attrs = attributes || {};
    options || (options = {});
    this.cid = _.uniqueId('c');
    this.attributes = {};
    _.extend(this, _.pick(options, modelOptions));
    if (options.parse) attrs = this.parse(attrs, options) || {};
    if (defaults = _.result(this, 'defaults')) {
      attrs = _.defaults({}, attrs, defaults);
    }
    this.set(attrs, options);
    this.changed = {};
    this.initialize.apply(this, arguments);
  };

  // A list of options to be attached directly to the model, if provided.
  var modelOptions = ['url', 'urlRoot', 'collection'];

  // Attach all inheritable methods to the Model prototype.
  _.extend(Model.prototype, Events, {

    // A hash of attributes whose current and previous value differ.
    changed: null,

    // The value returned during the last failed validation.
    validationError: null,

    // The default name for the JSON `id` attribute is `"id"`. MongoDB and
    // CouchDB users may want to set this to `"_id"`.
    idAttribute: 'id',

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Return a copy of the model's `attributes` object.
    toJSON: function(options) {
      return _.clone(this.attributes);
    },

    // Proxy `Backbone.sync` by default -- but override this if you need
    // custom syncing semantics for *this* particular model.
    sync: function() {
      return Backbone.sync.apply(this, arguments);
    },

    // Get the value of an attribute.
    get: function(attr) {
      return this.attributes[attr];
    },

    // Get the HTML-escaped value of an attribute.
    escape: function(attr) {
      return _.escape(this.get(attr));
    },

    // Returns `true` if the attribute contains a value that is not null
    // or undefined.
    has: function(attr) {
      return this.get(attr) != null;
    },

    // Set a hash of model attributes on the object, firing `"change"`. This is
    // the core primitive operation of a model, updating the data and notifying
    // anyone who needs to know about the change in state. The heart of the beast.
    set: function(key, val, options) {
      var attr, attrs, unset, changes, silent, changing, prev, current;
      if (key == null) return this;

      // Handle both `"key", value` and `{key: value}` -style arguments.
      if (typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      options || (options = {});

      // Run validation.
      if (!this._validate(attrs, options)) return false;

      // Extract attributes and options.
      unset           = options.unset;
      silent          = options.silent;
      changes         = [];
      changing        = this._changing;
      this._changing  = true;

      if (!changing) {
        this._previousAttributes = _.clone(this.attributes);
        this.changed = {};
      }
      current = this.attributes, prev = this._previousAttributes;

      // Check for changes of `id`.
      if (this.idAttribute in attrs) this.id = attrs[this.idAttribute];

      // For each `set` attribute, update or delete the current value.
      for (attr in attrs) {
        val = attrs[attr];
        if (!_.isEqual(current[attr], val)) changes.push(attr);
        if (!_.isEqual(prev[attr], val)) {
          this.changed[attr] = val;
        } else {
          delete this.changed[attr];
        }
        unset ? delete current[attr] : current[attr] = val;
      }

      // Trigger all relevant attribute changes.
      if (!silent) {
        if (changes.length) this._pending = true;
        for (var i = 0, l = changes.length; i < l; i++) {
          this.trigger('change:' + changes[i], this, current[changes[i]], options);
        }
      }

      // You might be wondering why there's a `while` loop here. Changes can
      // be recursively nested within `"change"` events.
      if (changing) return this;
      if (!silent) {
        while (this._pending) {
          this._pending = false;
          this.trigger('change', this, options);
        }
      }
      this._pending = false;
      this._changing = false;
      return this;
    },

    // Remove an attribute from the model, firing `"change"`. `unset` is a noop
    // if the attribute doesn't exist.
    unset: function(attr, options) {
      return this.set(attr, void 0, _.extend({}, options, {unset: true}));
    },

    // Clear all attributes on the model, firing `"change"`.
    clear: function(options) {
      var attrs = {};
      for (var key in this.attributes) attrs[key] = void 0;
      return this.set(attrs, _.extend({}, options, {unset: true}));
    },

    // Determine if the model has changed since the last `"change"` event.
    // If you specify an attribute name, determine if that attribute has changed.
    hasChanged: function(attr) {
      if (attr == null) return !_.isEmpty(this.changed);
      return _.has(this.changed, attr);
    },

    // Return an object containing all the attributes that have changed, or
    // false if there are no changed attributes. Useful for determining what
    // parts of a view need to be updated and/or what attributes need to be
    // persisted to the server. Unset attributes will be set to undefined.
    // You can also pass an attributes object to diff against the model,
    // determining if there *would be* a change.
    changedAttributes: function(diff) {
      if (!diff) return this.hasChanged() ? _.clone(this.changed) : false;
      var val, changed = false;
      var old = this._changing ? this._previousAttributes : this.attributes;
      for (var attr in diff) {
        if (_.isEqual(old[attr], (val = diff[attr]))) continue;
        (changed || (changed = {}))[attr] = val;
      }
      return changed;
    },

    // Get the previous value of an attribute, recorded at the time the last
    // `"change"` event was fired.
    previous: function(attr) {
      if (attr == null || !this._previousAttributes) return null;
      return this._previousAttributes[attr];
    },

    // Get all of the attributes of the model at the time of the previous
    // `"change"` event.
    previousAttributes: function() {
      return _.clone(this._previousAttributes);
    },

    // Fetch the model from the server. If the server's representation of the
    // model differs from its current attributes, they will be overridden,
    // triggering a `"change"` event.
    fetch: function(options) {
      options = options ? _.clone(options) : {};
      if (options.parse === void 0) options.parse = true;
      var model = this;
      var success = options.success;
      options.success = function(resp) {
        if (!model.set(model.parse(resp, options), options)) return false;
        if (success) success(model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Set a hash of model attributes, and sync the model to the server.
    // If the server returns an attributes hash that differs, the model's
    // state will be `set` again.
    save: function(key, val, options) {
      var attrs, method, xhr, attributes = this.attributes;

      // Handle both `"key", value` and `{key: value}` -style arguments.
      if (key == null || typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      // If we're not waiting and attributes exist, save acts as `set(attr).save(null, opts)`.
      if (attrs && (!options || !options.wait) && !this.set(attrs, options)) return false;

      options = _.extend({validate: true}, options);

      // Do not persist invalid models.
      if (!this._validate(attrs, options)) return false;

      // Set temporary attributes if `{wait: true}`.
      if (attrs && options.wait) {
        this.attributes = _.extend({}, attributes, attrs);
      }

      // After a successful server-side save, the client is (optionally)
      // updated with the server-side state.
      if (options.parse === void 0) options.parse = true;
      var model = this;
      var success = options.success;
      options.success = function(resp) {
        // Ensure attributes are restored during synchronous saves.
        model.attributes = attributes;
        var serverAttrs = model.parse(resp, options);
        if (options.wait) serverAttrs = _.extend(attrs || {}, serverAttrs);
        if (_.isObject(serverAttrs) && !model.set(serverAttrs, options)) {
          return false;
        }
        if (success) success(model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);

      method = this.isNew() ? 'create' : (options.patch ? 'patch' : 'update');
      if (method === 'patch') options.attrs = attrs;
      xhr = this.sync(method, this, options);

      // Restore attributes.
      if (attrs && options.wait) this.attributes = attributes;

      return xhr;
    },

    // Destroy this model on the server if it was already persisted.
    // Optimistically removes the model from its collection, if it has one.
    // If `wait: true` is passed, waits for the server to respond before removal.
    destroy: function(options) {
      options = options ? _.clone(options) : {};
      var model = this;
      var success = options.success;

      var destroy = function() {
        model.trigger('destroy', model, model.collection, options);
      };

      options.success = function(resp) {
        if (options.wait || model.isNew()) destroy();
        if (success) success(model, resp, options);
        if (!model.isNew()) model.trigger('sync', model, resp, options);
      };

      if (this.isNew()) {
        options.success();
        return false;
      }
      wrapError(this, options);

      var xhr = this.sync('delete', this, options);
      if (!options.wait) destroy();
      return xhr;
    },

    // Default URL for the model's representation on the server -- if you're
    // using Backbone's restful methods, override this to change the endpoint
    // that will be called.
    url: function() {
      var base = _.result(this, 'urlRoot') || _.result(this.collection, 'url') || urlError();
      if (this.isNew()) return base;
      return base + (base.charAt(base.length - 1) === '/' ? '' : '/') + encodeURIComponent(this.id);
    },

    // **parse** converts a response into the hash of attributes to be `set` on
    // the model. The default implementation is just to pass the response along.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new model with identical attributes to this one.
    clone: function() {
      return new this.constructor(this.attributes);
    },

    // A model is new if it has never been saved to the server, and lacks an id.
    isNew: function() {
      return this.id == null;
    },

    // Check if the model is currently in a valid state.
    isValid: function(options) {
      return this._validate({}, _.extend(options || {}, { validate: true }));
    },

    // Run validation against the next complete set of model attributes,
    // returning `true` if all is well. Otherwise, fire an `"invalid"` event.
    _validate: function(attrs, options) {
      if (!options.validate || !this.validate) return true;
      attrs = _.extend({}, this.attributes, attrs);
      var error = this.validationError = this.validate(attrs, options) || null;
      if (!error) return true;
      this.trigger('invalid', this, error, _.extend(options || {}, {validationError: error}));
      return false;
    }

  });

  // Underscore methods that we want to implement on the Model.
  var modelMethods = ['keys', 'values', 'pairs', 'invert', 'pick', 'omit'];

  // Mix in each Underscore method as a proxy to `Model#attributes`.
  _.each(modelMethods, function(method) {
    Model.prototype[method] = function() {
      var args = slice.call(arguments);
      args.unshift(this.attributes);
      return _[method].apply(_, args);
    };
  });

  // Backbone.Collection
  // -------------------

  // If models tend to represent a single row of data, a Backbone Collection is
  // more analagous to a table full of data ... or a small slice or page of that
  // table, or a collection of rows that belong together for a particular reason
  // -- all of the messages in this particular folder, all of the documents
  // belonging to this particular author, and so on. Collections maintain
  // indexes of their models, both in order, and for lookup by `id`.

  // Create a new **Collection**, perhaps to contain a specific type of `model`.
  // If a `comparator` is specified, the Collection will maintain
  // its models in sort order, as they're added and removed.
  var Collection = Backbone.Collection = function(models, options) {
    options || (options = {});
    if (options.url) this.url = options.url;
    if (options.model) this.model = options.model;
    if (options.comparator !== void 0) this.comparator = options.comparator;
    this._reset();
    this.initialize.apply(this, arguments);
    if (models) this.reset(models, _.extend({silent: true}, options));
  };

  // Default options for `Collection#set`.
  var setOptions = {add: true, remove: true, merge: true};
  var addOptions = {add: true, merge: false, remove: false};

  // Define the Collection's inheritable methods.
  _.extend(Collection.prototype, Events, {

    // The default model for a collection is just a **Backbone.Model**.
    // This should be overridden in most cases.
    model: Model,

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // The JSON representation of a Collection is an array of the
    // models' attributes.
    toJSON: function(options) {
      return this.map(function(model){ return model.toJSON(options); });
    },

    // Proxy `Backbone.sync` by default.
    sync: function() {
      return Backbone.sync.apply(this, arguments);
    },

    // Add a model, or list of models to the set.
    add: function(models, options) {
      return this.set(models, _.defaults(options || {}, addOptions));
    },

    // Remove a model, or a list of models from the set.
    remove: function(models, options) {
      models = _.isArray(models) ? models.slice() : [models];
      options || (options = {});
      var i, l, index, model;
      for (i = 0, l = models.length; i < l; i++) {
        model = this.get(models[i]);
        if (!model) continue;
        delete this._byId[model.id];
        delete this._byId[model.cid];
        index = this.indexOf(model);
        this.models.splice(index, 1);
        this.length--;
        if (!options.silent) {
          options.index = index;
          model.trigger('remove', model, this, options);
        }
        this._removeReference(model);
      }
      return this;
    },

    // Update a collection by `set`-ing a new list of models, adding new ones,
    // removing models that are no longer present, and merging models that
    // already exist in the collection, as necessary. Similar to **Model#set**,
    // the core operation for updating the data contained by the collection.
    set: function(models, options) {
      options = _.defaults(options || {}, setOptions);
      if (options.parse) models = this.parse(models, options);
      if (!_.isArray(models)) models = models ? [models] : [];
      var i, l, model, attrs, existing, sort;
      var at = options.at;
      var sortable = this.comparator && (at == null) && options.sort !== false;
      var sortAttr = _.isString(this.comparator) ? this.comparator : null;
      var toAdd = [], toRemove = [], modelMap = {};

      // Turn bare objects into model references, and prevent invalid models
      // from being added.
      for (i = 0, l = models.length; i < l; i++) {
        if (!(model = this._prepareModel(models[i], options))) continue;

        // If a duplicate is found, prevent it from being added and
        // optionally merge it into the existing model.
        if (existing = this.get(model)) {
          if (options.remove) modelMap[existing.cid] = true;
          if (options.merge) {
            existing.set(model.attributes, options);
            if (sortable && !sort && existing.hasChanged(sortAttr)) sort = true;
          }

        // This is a new model, push it to the `toAdd` list.
        } else if (options.add) {
          toAdd.push(model);

          // Listen to added models' events, and index models for lookup by
          // `id` and by `cid`.
          model.on('all', this._onModelEvent, this);
          this._byId[model.cid] = model;
          if (model.id != null) this._byId[model.id] = model;
        }
      }

      // Remove nonexistent models if appropriate.
      if (options.remove) {
        for (i = 0, l = this.length; i < l; ++i) {
          if (!modelMap[(model = this.models[i]).cid]) toRemove.push(model);
        }
        if (toRemove.length) this.remove(toRemove, options);
      }

      // See if sorting is needed, update `length` and splice in new models.
      if (toAdd.length) {
        if (sortable) sort = true;
        this.length += toAdd.length;
        if (at != null) {
          splice.apply(this.models, [at, 0].concat(toAdd));
        } else {
          push.apply(this.models, toAdd);
        }
      }

      // Silently sort the collection if appropriate.
      if (sort) this.sort({silent: true});

      if (options.silent) return this;

      // Trigger `add` events.
      for (i = 0, l = toAdd.length; i < l; i++) {
        (model = toAdd[i]).trigger('add', model, this, options);
      }

      // Trigger `sort` if the collection was sorted.
      if (sort) this.trigger('sort', this, options);
      return this;
    },

    // When you have more items than you want to add or remove individually,
    // you can reset the entire set with a new list of models, without firing
    // any granular `add` or `remove` events. Fires `reset` when finished.
    // Useful for bulk operations and optimizations.
    reset: function(models, options) {
      options || (options = {});
      for (var i = 0, l = this.models.length; i < l; i++) {
        this._removeReference(this.models[i]);
      }
      options.previousModels = this.models;
      this._reset();
      this.add(models, _.extend({silent: true}, options));
      if (!options.silent) this.trigger('reset', this, options);
      return this;
    },

    // Add a model to the end of the collection.
    push: function(model, options) {
      model = this._prepareModel(model, options);
      this.add(model, _.extend({at: this.length}, options));
      return model;
    },

    // Remove a model from the end of the collection.
    pop: function(options) {
      var model = this.at(this.length - 1);
      this.remove(model, options);
      return model;
    },

    // Add a model to the beginning of the collection.
    unshift: function(model, options) {
      model = this._prepareModel(model, options);
      this.add(model, _.extend({at: 0}, options));
      return model;
    },

    // Remove a model from the beginning of the collection.
    shift: function(options) {
      var model = this.at(0);
      this.remove(model, options);
      return model;
    },

    // Slice out a sub-array of models from the collection.
    slice: function(begin, end) {
      return this.models.slice(begin, end);
    },

    // Get a model from the set by id.
    get: function(obj) {
      if (obj == null) return void 0;
      return this._byId[obj.id != null ? obj.id : obj.cid || obj];
    },

    // Get the model at the given index.
    at: function(index) {
      return this.models[index];
    },

    // Return models with matching attributes. Useful for simple cases of
    // `filter`.
    where: function(attrs, first) {
      if (_.isEmpty(attrs)) return first ? void 0 : [];
      return this[first ? 'find' : 'filter'](function(model) {
        for (var key in attrs) {
          if (attrs[key] !== model.get(key)) return false;
        }
        return true;
      });
    },

    // Return the first model with matching attributes. Useful for simple cases
    // of `find`.
    findWhere: function(attrs) {
      return this.where(attrs, true);
    },

    // Force the collection to re-sort itself. You don't need to call this under
    // normal circumstances, as the set will maintain sort order as each item
    // is added.
    sort: function(options) {
      if (!this.comparator) throw new Error('Cannot sort a set without a comparator');
      options || (options = {});

      // Run sort based on type of `comparator`.
      if (_.isString(this.comparator) || this.comparator.length === 1) {
        this.models = this.sortBy(this.comparator, this);
      } else {
        this.models.sort(_.bind(this.comparator, this));
      }

      if (!options.silent) this.trigger('sort', this, options);
      return this;
    },

    // Figure out the smallest index at which a model should be inserted so as
    // to maintain order.
    sortedIndex: function(model, value, context) {
      value || (value = this.comparator);
      var iterator = _.isFunction(value) ? value : function(model) {
        return model.get(value);
      };
      return _.sortedIndex(this.models, model, iterator, context);
    },

    // Pluck an attribute from each model in the collection.
    pluck: function(attr) {
      return _.invoke(this.models, 'get', attr);
    },

    // Fetch the default set of models for this collection, resetting the
    // collection when they arrive. If `reset: true` is passed, the response
    // data will be passed through the `reset` method instead of `set`.
    fetch: function(options) {
      options = options ? _.clone(options) : {};
      if (options.parse === void 0) options.parse = true;
      var success = options.success;
      var collection = this;
      options.success = function(resp) {
        var method = options.reset ? 'reset' : 'set';
        collection[method](resp, options);
        if (success) success(collection, resp, options);
        collection.trigger('sync', collection, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Create a new instance of a model in this collection. Add the model to the
    // collection immediately, unless `wait: true` is passed, in which case we
    // wait for the server to agree.
    create: function(model, options) {
      options = options ? _.clone(options) : {};
      if (!(model = this._prepareModel(model, options))) return false;
      if (!options.wait) this.add(model, options);
      var collection = this;
      var success = options.success;
      options.success = function(resp) {
        if (options.wait) collection.add(model, options);
        if (success) success(model, resp, options);
      };
      model.save(null, options);
      return model;
    },

    // **parse** converts a response into a list of models to be added to the
    // collection. The default implementation is just to pass it through.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new collection with an identical list of models as this one.
    clone: function() {
      return new this.constructor(this.models);
    },

    // Private method to reset all internal state. Called when the collection
    // is first initialized or reset.
    _reset: function() {
      this.length = 0;
      this.models = [];
      this._byId  = {};
    },

    // Prepare a hash of attributes (or other model) to be added to this
    // collection.
    _prepareModel: function(attrs, options) {
      if (attrs instanceof Model) {
        if (!attrs.collection) attrs.collection = this;
        return attrs;
      }
      options || (options = {});
      options.collection = this;
      var model = new this.model(attrs, options);
      if (!model._validate(attrs, options)) {
        this.trigger('invalid', this, attrs, options);
        return false;
      }
      return model;
    },

    // Internal method to sever a model's ties to a collection.
    _removeReference: function(model) {
      if (this === model.collection) delete model.collection;
      model.off('all', this._onModelEvent, this);
    },

    // Internal method called every time a model in the set fires an event.
    // Sets need to update their indexes when models change ids. All other
    // events simply proxy through. "add" and "remove" events that originate
    // in other collections are ignored.
    _onModelEvent: function(event, model, collection, options) {
      if ((event === 'add' || event === 'remove') && collection !== this) return;
      if (event === 'destroy') this.remove(model, options);
      if (model && event === 'change:' + model.idAttribute) {
        delete this._byId[model.previous(model.idAttribute)];
        if (model.id != null) this._byId[model.id] = model;
      }
      this.trigger.apply(this, arguments);
    }

  });

  // Underscore methods that we want to implement on the Collection.
  // 90% of the core usefulness of Backbone Collections is actually implemented
  // right here:
  var methods = ['forEach', 'each', 'map', 'collect', 'reduce', 'foldl',
    'inject', 'reduceRight', 'foldr', 'find', 'detect', 'filter', 'select',
    'reject', 'every', 'all', 'some', 'any', 'include', 'contains', 'invoke',
    'max', 'min', 'toArray', 'size', 'first', 'head', 'take', 'initial', 'rest',
    'tail', 'drop', 'last', 'without', 'indexOf', 'shuffle', 'lastIndexOf',
    'isEmpty', 'chain'];

  // Mix in each Underscore method as a proxy to `Collection#models`.
  _.each(methods, function(method) {
    Collection.prototype[method] = function() {
      var args = slice.call(arguments);
      args.unshift(this.models);
      return _[method].apply(_, args);
    };
  });

  // Underscore methods that take a property name as an argument.
  var attributeMethods = ['groupBy', 'countBy', 'sortBy'];

  // Use attributes instead of properties.
  _.each(attributeMethods, function(method) {
    Collection.prototype[method] = function(value, context) {
      var iterator = _.isFunction(value) ? value : function(model) {
        return model.get(value);
      };
      return _[method](this.models, iterator, context);
    };
  });

  // Backbone.View
  // -------------

  // Backbone Views are almost more convention than they are actual code. A View
  // is simply a JavaScript object that represents a logical chunk of UI in the
  // DOM. This might be a single item, an entire list, a sidebar or panel, or
  // even the surrounding frame which wraps your whole app. Defining a chunk of
  // UI as a **View** allows you to define your DOM events declaratively, without
  // having to worry about render order ... and makes it easy for the view to
  // react to specific changes in the state of your models.

  // Creating a Backbone.View creates its initial element outside of the DOM,
  // if an existing element is not provided...
  var View = Backbone.View = function(options) {
    this.cid = _.uniqueId('view');
    this._configure(options || {});
    this._ensureElement();
    this.initialize.apply(this, arguments);
    this.delegateEvents();
  };

  // Cached regex to split keys for `delegate`.
  var delegateEventSplitter = /^(\S+)\s*(.*)$/;

  // List of view options to be merged as properties.
  var viewOptions = ['model', 'collection', 'el', 'id', 'attributes', 'className', 'tagName', 'events'];

  // Set up all inheritable **Backbone.View** properties and methods.
  _.extend(View.prototype, Events, {

    // The default `tagName` of a View's element is `"div"`.
    tagName: 'div',

    // jQuery delegate for element lookup, scoped to DOM elements within the
    // current view. This should be prefered to global lookups where possible.
    $: function(selector) {
      return this.$el.find(selector);
    },

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // **render** is the core function that your view should override, in order
    // to populate its element (`this.el`), with the appropriate HTML. The
    // convention is for **render** to always return `this`.
    render: function() {
      return this;
    },

    // Remove this view by taking the element out of the DOM, and removing any
    // applicable Backbone.Events listeners.
    remove: function() {
      this.$el.remove();
      this.stopListening();
      return this;
    },

    // Change the view's element (`this.el` property), including event
    // re-delegation.
    setElement: function(element, delegate) {
      if (this.$el) this.undelegateEvents();
      this.$el = element instanceof Backbone.$ ? element : Backbone.$(element);
      this.el = this.$el[0];
      if (delegate !== false) this.delegateEvents();
      return this;
    },

    // Set callbacks, where `this.events` is a hash of
    //
    // *{"event selector": "callback"}*
    //
    //     {
    //       'mousedown .title':  'edit',
    //       'click .button':     'save'
    //       'click .open':       function(e) { ... }
    //     }
    //
    // pairs. Callbacks will be bound to the view, with `this` set properly.
    // Uses event delegation for efficiency.
    // Omitting the selector binds the event to `this.el`.
    // This only works for delegate-able events: not `focus`, `blur`, and
    // not `change`, `submit`, and `reset` in Internet Explorer.
    delegateEvents: function(events) {
      if (!(events || (events = _.result(this, 'events')))) return this;
      this.undelegateEvents();
      for (var key in events) {
        var method = events[key];
        if (!_.isFunction(method)) method = this[events[key]];
        if (!method) continue;

        var match = key.match(delegateEventSplitter);
        var eventName = match[1], selector = match[2];
        method = _.bind(method, this);
        eventName += '.delegateEvents' + this.cid;
        if (selector === '') {
          this.$el.on(eventName, method);
        } else {
          this.$el.on(eventName, selector, method);
        }
      }
      return this;
    },

    // Clears all callbacks previously bound to the view with `delegateEvents`.
    // You usually don't need to use this, but may wish to if you have multiple
    // Backbone views attached to the same DOM element.
    undelegateEvents: function() {
      this.$el.off('.delegateEvents' + this.cid);
      return this;
    },

    // Performs the initial configuration of a View with a set of options.
    // Keys with special meaning *(e.g. model, collection, id, className)* are
    // attached directly to the view.  See `viewOptions` for an exhaustive
    // list.
    _configure: function(options) {
      if (this.options) options = _.extend({}, _.result(this, 'options'), options);
      _.extend(this, _.pick(options, viewOptions));
      this.options = options;
    },

    // Ensure that the View has a DOM element to render into.
    // If `this.el` is a string, pass it through `$()`, take the first
    // matching element, and re-assign it to `el`. Otherwise, create
    // an element from the `id`, `className` and `tagName` properties.
    _ensureElement: function() {
      if (!this.el) {
        var attrs = _.extend({}, _.result(this, 'attributes'));
        if (this.id) attrs.id = _.result(this, 'id');
        if (this.className) attrs['class'] = _.result(this, 'className');
        var $el = Backbone.$('<' + _.result(this, 'tagName') + '>').attr(attrs);
        this.setElement($el, false);
      } else {
        this.setElement(_.result(this, 'el'), false);
      }
    }

  });

  // Backbone.sync
  // -------------

  // Override this function to change the manner in which Backbone persists
  // models to the server. You will be passed the type of request, and the
  // model in question. By default, makes a RESTful Ajax request
  // to the model's `url()`. Some possible customizations could be:
  //
  // * Use `setTimeout` to batch rapid-fire updates into a single request.
  // * Send up the models as XML instead of JSON.
  // * Persist models via WebSockets instead of Ajax.
  //
  // Turn on `Backbone.emulateHTTP` in order to send `PUT` and `DELETE` requests
  // as `POST`, with a `_method` parameter containing the true HTTP method,
  // as well as all requests with the body as `application/x-www-form-urlencoded`
  // instead of `application/json` with the model in a param named `model`.
  // Useful when interfacing with server-side languages like **PHP** that make
  // it difficult to read the body of `PUT` requests.
  Backbone.sync = function(method, model, options) {
    var type = methodMap[method];

    // Default options, unless specified.
    _.defaults(options || (options = {}), {
      emulateHTTP: Backbone.emulateHTTP,
      emulateJSON: Backbone.emulateJSON
    });

    // Default JSON-request options.
    var params = {type: type, dataType: 'json'};

    // Ensure that we have a URL.
    if (!options.url) {
      params.url = _.result(model, 'url') || urlError();
    }

    // Ensure that we have the appropriate request data.
    if (options.data == null && model && (method === 'create' || method === 'update' || method === 'patch')) {
      params.contentType = 'application/json';
      params.data = JSON.stringify(options.attrs || model.toJSON(options));
    }

    // For older servers, emulate JSON by encoding the request into an HTML-form.
    if (options.emulateJSON) {
      params.contentType = 'application/x-www-form-urlencoded';
      params.data = params.data ? {model: params.data} : {};
    }

    // For older servers, emulate HTTP by mimicking the HTTP method with `_method`
    // And an `X-HTTP-Method-Override` header.
    if (options.emulateHTTP && (type === 'PUT' || type === 'DELETE' || type === 'PATCH')) {
      params.type = 'POST';
      if (options.emulateJSON) params.data._method = type;
      var beforeSend = options.beforeSend;
      options.beforeSend = function(xhr) {
        xhr.setRequestHeader('X-HTTP-Method-Override', type);
        if (beforeSend) return beforeSend.apply(this, arguments);
      };
    }

    // Don't process data on a non-GET request.
    if (params.type !== 'GET' && !options.emulateJSON) {
      params.processData = false;
    }

    // If we're sending a `PATCH` request, and we're in an old Internet Explorer
    // that still has ActiveX enabled by default, override jQuery to use that
    // for XHR instead. Remove this line when jQuery supports `PATCH` on IE8.
    if (params.type === 'PATCH' && window.ActiveXObject &&
          !(window.external && window.external.msActiveXFilteringEnabled)) {
      params.xhr = function() {
        return new ActiveXObject("Microsoft.XMLHTTP");
      };
    }

    // Make the request, allowing the user to override any Ajax options.
    var xhr = options.xhr = Backbone.ajax(_.extend(params, options));
    model.trigger('request', model, xhr, options);
    return xhr;
  };

  // Map from CRUD to HTTP for our default `Backbone.sync` implementation.
  var methodMap = {
    'create': 'POST',
    'update': 'PUT',
    'patch':  'PATCH',
    'delete': 'DELETE',
    'read':   'GET'
  };

  // Set the default implementation of `Backbone.ajax` to proxy through to `$`.
  // Override this if you'd like to use a different library.
  Backbone.ajax = function() {
    return Backbone.$.ajax.apply(Backbone.$, arguments);
  };

  // Backbone.Router
  // ---------------

  // Routers map faux-URLs to actions, and fire events when routes are
  // matched. Creating a new one sets its `routes` hash, if not set statically.
  var Router = Backbone.Router = function(options) {
    options || (options = {});
    if (options.routes) this.routes = options.routes;
    this._bindRoutes();
    this.initialize.apply(this, arguments);
  };

  // Cached regular expressions for matching named param parts and splatted
  // parts of route strings.
  var optionalParam = /\((.*?)\)/g;
  var namedParam    = /(\(\?)?:\w+/g;
  var splatParam    = /\*\w+/g;
  var escapeRegExp  = /[\-{}\[\]+?.,\\\^$|#\s]/g;

  // Set up all inheritable **Backbone.Router** properties and methods.
  _.extend(Router.prototype, Events, {

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Manually bind a single named route to a callback. For example:
    //
    //     this.route('search/:query/p:num', 'search', function(query, num) {
    //       ...
    //     });
    //
    route: function(route, name, callback) {
      if (!_.isRegExp(route)) route = this._routeToRegExp(route);
      if (_.isFunction(name)) {
        callback = name;
        name = '';
      }
      if (!callback) callback = this[name];
      var router = this;
      Backbone.history.route(route, function(fragment) {
        var args = router._extractParameters(route, fragment);
        callback && callback.apply(router, args);
        router.trigger.apply(router, ['route:' + name].concat(args));
        router.trigger('route', name, args);
        Backbone.history.trigger('route', router, name, args);
      });
      return this;
    },

    // Simple proxy to `Backbone.history` to save a fragment into the history.
    navigate: function(fragment, options) {
      Backbone.history.navigate(fragment, options);
      return this;
    },

    // Bind all defined routes to `Backbone.history`. We have to reverse the
    // order of the routes here to support behavior where the most general
    // routes can be defined at the bottom of the route map.
    _bindRoutes: function() {
      if (!this.routes) return;
      this.routes = _.result(this, 'routes');
      var route, routes = _.keys(this.routes);
      while ((route = routes.pop()) != null) {
        this.route(route, this.routes[route]);
      }
    },

    // Convert a route string into a regular expression, suitable for matching
    // against the current location hash.
    _routeToRegExp: function(route) {
      route = route.replace(escapeRegExp, '\\$&')
                   .replace(optionalParam, '(?:$1)?')
                   .replace(namedParam, function(match, optional){
                     return optional ? match : '([^\/]+)';
                   })
                   .replace(splatParam, '(.*?)');
      return new RegExp('^' + route + '$');
    },

    // Given a route, and a URL fragment that it matches, return the array of
    // extracted decoded parameters. Empty or unmatched parameters will be
    // treated as `null` to normalize cross-browser behavior.
    _extractParameters: function(route, fragment) {
      var params = route.exec(fragment).slice(1);
      return _.map(params, function(param) {
        return param ? decodeURIComponent(param) : null;
      });
    }

  });

  // Backbone.History
  // ----------------

  // Handles cross-browser history management, based on either
  // [pushState](http://diveintohtml5.info/history.html) and real URLs, or
  // [onhashchange](https://developer.mozilla.org/en-US/docs/DOM/window.onhashchange)
  // and URL fragments. If the browser supports neither (old IE, natch),
  // falls back to polling.
  var History = Backbone.History = function() {
    this.handlers = [];
    _.bindAll(this, 'checkUrl');

    // Ensure that `History` can be used outside of the browser.
    if (typeof window !== 'undefined') {
      this.location = window.location;
      this.history = window.history;
    }
  };

  // Cached regex for stripping a leading hash/slash and trailing space.
  var routeStripper = /^[#\/]|\s+$/g;

  // Cached regex for stripping leading and trailing slashes.
  var rootStripper = /^\/+|\/+$/g;

  // Cached regex for detecting MSIE.
  var isExplorer = /msie [\w.]+/;

  // Cached regex for removing a trailing slash.
  var trailingSlash = /\/$/;

  // Has the history handling already been started?
  History.started = false;

  // Set up all inheritable **Backbone.History** properties and methods.
  _.extend(History.prototype, Events, {

    // The default interval to poll for hash changes, if necessary, is
    // twenty times a second.
    interval: 50,

    // Gets the true hash value. Cannot use location.hash directly due to bug
    // in Firefox where location.hash will always be decoded.
    getHash: function(window) {
      var match = (window || this).location.href.match(/#(.*)$/);
      return match ? match[1] : '';
    },

    // Get the cross-browser normalized URL fragment, either from the URL,
    // the hash, or the override.
    getFragment: function(fragment, forcePushState) {
      if (fragment == null) {
        if (this._hasPushState || !this._wantsHashChange || forcePushState) {
          fragment = this.location.pathname;
          var root = this.root.replace(trailingSlash, '');
          if (!fragment.indexOf(root)) fragment = fragment.substr(root.length);
        } else {
          fragment = this.getHash();
        }
      }
      return fragment.replace(routeStripper, '');
    },

    // Start the hash change handling, returning `true` if the current URL matches
    // an existing route, and `false` otherwise.
    start: function(options) {
      if (History.started) throw new Error("Backbone.history has already been started");
      History.started = true;

      // Figure out the initial configuration. Do we need an iframe?
      // Is pushState desired ... is it available?
      this.options          = _.extend({}, {root: '/'}, this.options, options);
      this.root             = this.options.root;
      this._wantsHashChange = this.options.hashChange !== false;
      this._wantsPushState  = !!this.options.pushState;
      this._hasPushState    = !!(this.options.pushState && this.history && this.history.pushState);
      var fragment          = this.getFragment();
      var docMode           = document.documentMode;
      var oldIE             = (isExplorer.exec(navigator.userAgent.toLowerCase()) && (!docMode || docMode <= 7));

      // Normalize root to always include a leading and trailing slash.
      this.root = ('/' + this.root + '/').replace(rootStripper, '/');

      if (oldIE && this._wantsHashChange) {
        this.iframe = Backbone.$('<iframe src="javascript:0" tabindex="-1" />').hide().appendTo('body')[0].contentWindow;
        this.navigate(fragment);
      }

      // Depending on whether we're using pushState or hashes, and whether
      // 'onhashchange' is supported, determine how we check the URL state.
      if (this._hasPushState) {
        Backbone.$(window).on('popstate', this.checkUrl);
      } else if (this._wantsHashChange && ('onhashchange' in window) && !oldIE) {
        Backbone.$(window).on('hashchange', this.checkUrl);
      } else if (this._wantsHashChange) {
        this._checkUrlInterval = setInterval(this.checkUrl, this.interval);
      }

      // Determine if we need to change the base url, for a pushState link
      // opened by a non-pushState browser.
      this.fragment = fragment;
      var loc = this.location;
      var atRoot = loc.pathname.replace(/[^\/]$/, '$&/') === this.root;

      // If we've started off with a route from a `pushState`-enabled browser,
      // but we're currently in a browser that doesn't support it...
      if (this._wantsHashChange && this._wantsPushState && !this._hasPushState && !atRoot) {
        this.fragment = this.getFragment(null, true);
        this.location.replace(this.root + this.location.search + '#' + this.fragment);
        // Return immediately as browser will do redirect to new url
        return true;

      // Or if we've started out with a hash-based route, but we're currently
      // in a browser where it could be `pushState`-based instead...
      } else if (this._wantsPushState && this._hasPushState && atRoot && loc.hash) {
        this.fragment = this.getHash().replace(routeStripper, '');
        this.history.replaceState({}, document.title, this.root + this.fragment + loc.search);
      }

      if (!this.options.silent) return this.loadUrl();
    },

    // Disable Backbone.history, perhaps temporarily. Not useful in a real app,
    // but possibly useful for unit testing Routers.
    stop: function() {
      Backbone.$(window).off('popstate', this.checkUrl).off('hashchange', this.checkUrl);
      clearInterval(this._checkUrlInterval);
      History.started = false;
    },

    // Add a route to be tested when the fragment changes. Routes added later
    // may override previous routes.
    route: function(route, callback) {
      this.handlers.unshift({route: route, callback: callback});
    },

    // Checks the current URL to see if it has changed, and if it has,
    // calls `loadUrl`, normalizing across the hidden iframe.
    checkUrl: function(e) {
      var current = this.getFragment();
      if (current === this.fragment && this.iframe) {
        current = this.getFragment(this.getHash(this.iframe));
      }
      if (current === this.fragment) return false;
      if (this.iframe) this.navigate(current);
      this.loadUrl() || this.loadUrl(this.getHash());
    },

    // Attempt to load the current URL fragment. If a route succeeds with a
    // match, returns `true`. If no defined routes matches the fragment,
    // returns `false`.
    loadUrl: function(fragmentOverride) {
      var fragment = this.fragment = this.getFragment(fragmentOverride);
      var matched = _.any(this.handlers, function(handler) {
        if (handler.route.test(fragment)) {
          handler.callback(fragment);
          return true;
        }
      });
      return matched;
    },

    // Save a fragment into the hash history, or replace the URL state if the
    // 'replace' option is passed. You are responsible for properly URL-encoding
    // the fragment in advance.
    //
    // The options object can contain `trigger: true` if you wish to have the
    // route callback be fired (not usually desirable), or `replace: true`, if
    // you wish to modify the current URL without adding an entry to the history.
    navigate: function(fragment, options) {
      if (!History.started) return false;
      if (!options || options === true) options = {trigger: options};
      fragment = this.getFragment(fragment || '');
      if (this.fragment === fragment) return;
      this.fragment = fragment;
      var url = this.root + fragment;

      // If pushState is available, we use it to set the fragment as a real URL.
      if (this._hasPushState) {
        this.history[options.replace ? 'replaceState' : 'pushState']({}, document.title, url);

      // If hash changes haven't been explicitly disabled, update the hash
      // fragment to store history.
      } else if (this._wantsHashChange) {
        this._updateHash(this.location, fragment, options.replace);
        if (this.iframe && (fragment !== this.getFragment(this.getHash(this.iframe)))) {
          // Opening and closing the iframe tricks IE7 and earlier to push a
          // history entry on hash-tag change.  When replace is true, we don't
          // want this.
          if(!options.replace) this.iframe.document.open().close();
          this._updateHash(this.iframe.location, fragment, options.replace);
        }

      // If you've told us that you explicitly don't want fallback hashchange-
      // based history, then `navigate` becomes a page refresh.
      } else {
        return this.location.assign(url);
      }
      if (options.trigger) this.loadUrl(fragment);
    },

    // Update the hash location, either replacing the current entry, or adding
    // a new one to the browser history.
    _updateHash: function(location, fragment, replace) {
      if (replace) {
        var href = location.href.replace(/(javascript:|#).*$/, '');
        location.replace(href + '#' + fragment);
      } else {
        // Some browsers require that `hash` contains a leading #.
        location.hash = '#' + fragment;
      }
    }

  });

  // Create the default Backbone.history.
  Backbone.history = new History;

  // Helpers
  // -------

  // Helper function to correctly set up the prototype chain, for subclasses.
  // Similar to `goog.inherits`, but uses a hash of prototype properties and
  // class properties to be extended.
  var extend = function(protoProps, staticProps) {
    var parent = this;
    var child;

    // The constructor function for the new subclass is either defined by you
    // (the "constructor" property in your `extend` definition), or defaulted
    // by us to simply call the parent's constructor.
    if (protoProps && _.has(protoProps, 'constructor')) {
      child = protoProps.constructor;
    } else {
      child = function(){ return parent.apply(this, arguments); };
    }

    // Add static properties to the constructor function, if supplied.
    _.extend(child, parent, staticProps);

    // Set the prototype chain to inherit from `parent`, without calling
    // `parent`'s constructor function.
    var Surrogate = function(){ this.constructor = child; };
    Surrogate.prototype = parent.prototype;
    child.prototype = new Surrogate;

    // Add prototype properties (instance properties) to the subclass,
    // if supplied.
    if (protoProps) _.extend(child.prototype, protoProps);

    // Set a convenience property in case the parent's prototype is needed
    // later.
    child.__super__ = parent.prototype;

    return child;
  };

  // Set up inheritance for the model, collection, router, view and history.
  Model.extend = Collection.extend = Router.extend = View.extend = History.extend = extend;

  // Throw an error when a URL is needed, and none is supplied.
  var urlError = function() {
    throw new Error('A "url" property or function must be specified');
  };

  // Wrap an optional error callback with a fallback error event.
  var wrapError = function (model, options) {
    var error = options.error;
    options.error = function(resp) {
      if (error) error(model, resp, options);
      model.trigger('error', model, resp, options);
    };
  };

}).call(this);

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],10:[function(require,module,exports){
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */

(function (Hogan) {
  // Setup regex  assignments
  // remove whitespace according to Mustache spec
  var rIsWhitespace = /\S/,
      rQuot = /\"/g,
      rNewline =  /\n/g,
      rCr = /\r/g,
      rSlash = /\\/g,
      rLineSep = /\u2028/,
      rParagraphSep = /\u2029/;

  Hogan.tags = {
    '#': 1, '^': 2, '<': 3, '$': 4,
    '/': 5, '!': 6, '>': 7, '=': 8, '_v': 9,
    '{': 10, '&': 11, '_t': 12
  };

  Hogan.scan = function scan(text, delimiters) {
    var len = text.length,
        IN_TEXT = 0,
        IN_TAG_TYPE = 1,
        IN_TAG = 2,
        state = IN_TEXT,
        tagType = null,
        tag = null,
        buf = '',
        tokens = [],
        seenTag = false,
        i = 0,
        lineStart = 0,
        otag = '{{',
        ctag = '}}';

    function addBuf() {
      if (buf.length > 0) {
        tokens.push({tag: '_t', text: new String(buf)});
        buf = '';
      }
    }

    function lineIsWhitespace() {
      var isAllWhitespace = true;
      for (var j = lineStart; j < tokens.length; j++) {
        isAllWhitespace =
          (Hogan.tags[tokens[j].tag] < Hogan.tags['_v']) ||
          (tokens[j].tag == '_t' && tokens[j].text.match(rIsWhitespace) === null);
        if (!isAllWhitespace) {
          return false;
        }
      }

      return isAllWhitespace;
    }

    function filterLine(haveSeenTag, noNewLine) {
      addBuf();

      if (haveSeenTag && lineIsWhitespace()) {
        for (var j = lineStart, next; j < tokens.length; j++) {
          if (tokens[j].text) {
            if ((next = tokens[j+1]) && next.tag == '>') {
              // set indent to token value
              next.indent = tokens[j].text.toString()
            }
            tokens.splice(j, 1);
          }
        }
      } else if (!noNewLine) {
        tokens.push({tag:'\n'});
      }

      seenTag = false;
      lineStart = tokens.length;
    }

    function changeDelimiters(text, index) {
      var close = '=' + ctag,
          closeIndex = text.indexOf(close, index),
          delimiters = trim(
            text.substring(text.indexOf('=', index) + 1, closeIndex)
          ).split(' ');

      otag = delimiters[0];
      ctag = delimiters[delimiters.length - 1];

      return closeIndex + close.length - 1;
    }

    if (delimiters) {
      delimiters = delimiters.split(' ');
      otag = delimiters[0];
      ctag = delimiters[1];
    }

    for (i = 0; i < len; i++) {
      if (state == IN_TEXT) {
        if (tagChange(otag, text, i)) {
          --i;
          addBuf();
          state = IN_TAG_TYPE;
        } else {
          if (text.charAt(i) == '\n') {
            filterLine(seenTag);
          } else {
            buf += text.charAt(i);
          }
        }
      } else if (state == IN_TAG_TYPE) {
        i += otag.length - 1;
        tag = Hogan.tags[text.charAt(i + 1)];
        tagType = tag ? text.charAt(i + 1) : '_v';
        if (tagType == '=') {
          i = changeDelimiters(text, i);
          state = IN_TEXT;
        } else {
          if (tag) {
            i++;
          }
          state = IN_TAG;
        }
        seenTag = i;
      } else {
        if (tagChange(ctag, text, i)) {
          tokens.push({tag: tagType, n: trim(buf), otag: otag, ctag: ctag,
                       i: (tagType == '/') ? seenTag - otag.length : i + ctag.length});
          buf = '';
          i += ctag.length - 1;
          state = IN_TEXT;
          if (tagType == '{') {
            if (ctag == '}}') {
              i++;
            } else {
              cleanTripleStache(tokens[tokens.length - 1]);
            }
          }
        } else {
          buf += text.charAt(i);
        }
      }
    }

    filterLine(seenTag, true);

    return tokens;
  }

  function cleanTripleStache(token) {
    if (token.n.substr(token.n.length - 1) === '}') {
      token.n = token.n.substring(0, token.n.length - 1);
    }
  }

  function trim(s) {
    if (s.trim) {
      return s.trim();
    }

    return s.replace(/^\s*|\s*$/g, '');
  }

  function tagChange(tag, text, index) {
    if (text.charAt(index) != tag.charAt(0)) {
      return false;
    }

    for (var i = 1, l = tag.length; i < l; i++) {
      if (text.charAt(index + i) != tag.charAt(i)) {
        return false;
      }
    }

    return true;
  }

  // the tags allowed inside super templates
  var allowedInSuper = {'_t': true, '\n': true, '$': true, '/': true};

  function buildTree(tokens, kind, stack, customTags) {
    var instructions = [],
        opener = null,
        tail = null,
        token = null;

    tail = stack[stack.length - 1];

    while (tokens.length > 0) {
      token = tokens.shift();

      if (tail && tail.tag == '<' && !(token.tag in allowedInSuper)) {
        throw new Error('Illegal content in < super tag.');
      }

      if (Hogan.tags[token.tag] <= Hogan.tags['$'] || isOpener(token, customTags)) {
        stack.push(token);
        token.nodes = buildTree(tokens, token.tag, stack, customTags);
      } else if (token.tag == '/') {
        if (stack.length === 0) {
          throw new Error('Closing tag without opener: /' + token.n);
        }
        opener = stack.pop();
        if (token.n != opener.n && !isCloser(token.n, opener.n, customTags)) {
          throw new Error('Nesting error: ' + opener.n + ' vs. ' + token.n);
        }
        opener.end = token.i;
        return instructions;
      } else if (token.tag == '\n') {
        token.last = (tokens.length == 0) || (tokens[0].tag == '\n');
      }

      instructions.push(token);
    }

    if (stack.length > 0) {
      throw new Error('missing closing tag: ' + stack.pop().n);
    }

    return instructions;
  }

  function isOpener(token, tags) {
    for (var i = 0, l = tags.length; i < l; i++) {
      if (tags[i].o == token.n) {
        token.tag = '#';
        return true;
      }
    }
  }

  function isCloser(close, open, tags) {
    for (var i = 0, l = tags.length; i < l; i++) {
      if (tags[i].c == close && tags[i].o == open) {
        return true;
      }
    }
  }

  function stringifySubstitutions(obj) {
    var items = [];
    for (var key in obj) {
      items.push('"' + esc(key) + '": function(c,p,t,i) {' + obj[key] + '}');
    }
    return "{ " + items.join(",") + " }";
  }

  function stringifyPartials(codeObj) {
    var partials = [];
    for (var key in codeObj.partials) {
      partials.push('"' + esc(key) + '":{name:"' + esc(codeObj.partials[key].name) + '", ' + stringifyPartials(codeObj.partials[key]) + "}");
    }
    return "partials: {" + partials.join(",") + "}, subs: " + stringifySubstitutions(codeObj.subs);
  }

  Hogan.stringify = function(codeObj, text, options) {
    return "{code: function (c,p,i) { " + Hogan.wrapMain(codeObj.code) + " }," + stringifyPartials(codeObj) +  "}";
  }

  var serialNo = 0;
  Hogan.generate = function(tree, text, options) {
    serialNo = 0;
    var context = { code: '', subs: {}, partials: {} };
    Hogan.walk(tree, context);

    if (options.asString) {
      return this.stringify(context, text, options);
    }

    return this.makeTemplate(context, text, options);
  }

  Hogan.wrapMain = function(code) {
    return 'var t=this;t.b(i=i||"");' + code + 'return t.fl();';
  }

  Hogan.template = Hogan.Template;

  Hogan.makeTemplate = function(codeObj, text, options) {
    var template = this.makePartials(codeObj);
    template.code = new Function('c', 'p', 'i', this.wrapMain(codeObj.code));
    return new this.template(template, text, this, options);
  }

  Hogan.makePartials = function(codeObj) {
    var key, template = {subs: {}, partials: codeObj.partials, name: codeObj.name};
    for (key in template.partials) {
      template.partials[key] = this.makePartials(template.partials[key]);
    }
    for (key in codeObj.subs) {
      template.subs[key] = new Function('c', 'p', 't', 'i', codeObj.subs[key]);
    }
    return template;
  }

  function esc(s) {
    return s.replace(rSlash, '\\\\')
            .replace(rQuot, '\\\"')
            .replace(rNewline, '\\n')
            .replace(rCr, '\\r')
            .replace(rLineSep, '\\u2028')
            .replace(rParagraphSep, '\\u2029');
  }

  function chooseMethod(s) {
    return (~s.indexOf('.')) ? 'd' : 'f';
  }

  function createPartial(node, context) {
    var prefix = "<" + (context.prefix || "");
    var sym = prefix + node.n + serialNo++;
    context.partials[sym] = {name: node.n, partials: {}};
    context.code += 't.b(t.rp("' +  esc(sym) + '",c,p,"' + (node.indent || '') + '"));';
    return sym;
  }

  Hogan.codegen = {
    '#': function(node, context) {
      context.code += 'if(t.s(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,1),' +
                      'c,p,0,' + node.i + ',' + node.end + ',"' + node.otag + " " + node.ctag + '")){' +
                      't.rs(c,p,' + 'function(c,p,t){';
      Hogan.walk(node.nodes, context);
      context.code += '});c.pop();}';
    },

    '^': function(node, context) {
      context.code += 'if(!t.s(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,1),c,p,1,0,0,"")){';
      Hogan.walk(node.nodes, context);
      context.code += '};';
    },

    '>': createPartial,
    '<': function(node, context) {
      var ctx = {partials: {}, code: '', subs: {}, inPartial: true};
      Hogan.walk(node.nodes, ctx);
      var template = context.partials[createPartial(node, context)];
      template.subs = ctx.subs;
      template.partials = ctx.partials;
    },

    '$': function(node, context) {
      var ctx = {subs: {}, code: '', partials: context.partials, prefix: node.n};
      Hogan.walk(node.nodes, ctx);
      context.subs[node.n] = ctx.code;
      if (!context.inPartial) {
        context.code += 't.sub("' + esc(node.n) + '",c,p,i);';
      }
    },

    '\n': function(node, context) {
      context.code += write('"\\n"' + (node.last ? '' : ' + i'));
    },

    '_v': function(node, context) {
      context.code += 't.b(t.v(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,0)));';
    },

    '_t': function(node, context) {
      context.code += write('"' + esc(node.text) + '"');
    },

    '{': tripleStache,

    '&': tripleStache
  }

  function tripleStache(node, context) {
    context.code += 't.b(t.t(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,0)));';
  }

  function write(s) {
    return 't.b(' + s + ');';
  }

  Hogan.walk = function(nodelist, context) {
    var func;
    for (var i = 0, l = nodelist.length; i < l; i++) {
      func = Hogan.codegen[nodelist[i].tag];
      func && func(nodelist[i], context);
    }
    return context;
  }

  Hogan.parse = function(tokens, text, options) {
    options = options || {};
    return buildTree(tokens, '', [], options.sectionTags || []);
  }

  Hogan.cache = {};

  Hogan.cacheKey = function(text, options) {
    return [text, !!options.asString, !!options.disableLambda, options.delimiters, !!options.modelGet].join('||');
  }

  Hogan.compile = function(text, options) {
    options = options || {};
    var key = Hogan.cacheKey(text, options);
    var template = this.cache[key];

    if (template) {
      var partials = template.partials;
      for (var name in partials) {
        delete partials[name].instance;
      }
      return template;
    }

    template = this.generate(this.parse(this.scan(text, options.delimiters), text, options), text, options);
    return this.cache[key] = template;
  }
})(typeof exports !== 'undefined' ? exports : Hogan);

},{}],11:[function(require,module,exports){
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */

// This file is for use with Node.js. See dist/ for browser files.

var Hogan = require('./compiler');
Hogan.Template = require('./template').Template;
Hogan.template = Hogan.Template;
module.exports = Hogan;

},{"./compiler":10,"./template":12}],12:[function(require,module,exports){
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */

var Hogan = {};

(function (Hogan) {
  Hogan.Template = function (codeObj, text, compiler, options) {
    codeObj = codeObj || {};
    this.r = codeObj.code || this.r;
    this.c = compiler;
    this.options = options || {};
    this.text = text || '';
    this.partials = codeObj.partials || {};
    this.subs = codeObj.subs || {};
    this.buf = '';
  }

  Hogan.Template.prototype = {
    // render: replaced by generated code.
    r: function (context, partials, indent) { return ''; },

    // variable escaping
    v: hoganEscape,

    // triple stache
    t: coerceToString,

    render: function render(context, partials, indent) {
      return this.ri([context], partials || {}, indent);
    },

    // render internal -- a hook for overrides that catches partials too
    ri: function (context, partials, indent) {
      return this.r(context, partials, indent);
    },

    // ensurePartial
    ep: function(symbol, partials) {
      var partial = this.partials[symbol];

      // check to see that if we've instantiated this partial before
      var template = partials[partial.name];
      if (partial.instance && partial.base == template) {
        return partial.instance;
      }

      if (typeof template == 'string') {
        if (!this.c) {
          throw new Error("No compiler available.");
        }
        template = this.c.compile(template, this.options);
      }

      if (!template) {
        return null;
      }

      // We use this to check whether the partials dictionary has changed
      this.partials[symbol].base = template;

      if (partial.subs) {
        // Make sure we consider parent template now
        if (!partials.stackText) partials.stackText = {};
        for (key in partial.subs) {
          if (!partials.stackText[key]) {
            partials.stackText[key] = (this.activeSub !== undefined && partials.stackText[this.activeSub]) ? partials.stackText[this.activeSub] : this.text;
          }
        }
        template = createSpecializedPartial(template, partial.subs, partial.partials,
          this.stackSubs, this.stackPartials, partials.stackText);
      }
      this.partials[symbol].instance = template;

      return template;
    },

    // tries to find a partial in the current scope and render it
    rp: function(symbol, context, partials, indent) {
      var partial = this.ep(symbol, partials);
      if (!partial) {
        return '';
      }

      return partial.ri(context, partials, indent);
    },

    // render a section
    rs: function(context, partials, section) {
      var tail = context[context.length - 1];

      if (!isArray(tail)) {
        section(context, partials, this);
        return;
      }

      for (var i = 0; i < tail.length; i++) {
        context.push(tail[i]);
        section(context, partials, this);
        context.pop();
      }
    },

    // maybe start a section
    s: function(val, ctx, partials, inverted, start, end, tags) {
      var pass;

      if (isArray(val) && val.length === 0) {
        return false;
      }

      if (typeof val == 'function') {
        val = this.ms(val, ctx, partials, inverted, start, end, tags);
      }

      pass = !!val;

      if (!inverted && pass && ctx) {
        ctx.push((typeof val == 'object') ? val : ctx[ctx.length - 1]);
      }

      return pass;
    },

    // find values with dotted names
    d: function(key, ctx, partials, returnFound) {
      var found,
          names = key.split('.'),
          val = this.f(names[0], ctx, partials, returnFound),
          doModelGet = this.options.modelGet,
          cx = null;

      if (key === '.' && isArray(ctx[ctx.length - 2])) {
        val = ctx[ctx.length - 1];
      } else {
        for (var i = 1; i < names.length; i++) {
          found = findInScope(names[i], val, doModelGet);
          if (found !== undefined) {
            cx = val;
            val = found;
          } else {
            val = '';
          }
        }
      }

      if (returnFound && !val) {
        return false;
      }

      if (!returnFound && typeof val == 'function') {
        ctx.push(cx);
        val = this.mv(val, ctx, partials);
        ctx.pop();
      }

      return val;
    },

    // find values with normal names
    f: function(key, ctx, partials, returnFound) {
      var val = false,
          v = null,
          found = false,
          doModelGet = this.options.modelGet;

      for (var i = ctx.length - 1; i >= 0; i--) {
        v = ctx[i];
        val = findInScope(key, v, doModelGet);
        if (val !== undefined) {
          found = true;
          break;
        }
      }

      if (!found) {
        return (returnFound) ? false : "";
      }

      if (!returnFound && typeof val == 'function') {
        val = this.mv(val, ctx, partials);
      }

      return val;
    },

    // higher order templates
    ls: function(func, cx, partials, text, tags) {
      var oldTags = this.options.delimiters;

      this.options.delimiters = tags;
      this.b(this.ct(coerceToString(func.call(cx, text)), cx, partials));
      this.options.delimiters = oldTags;

      return false;
    },

    // compile text
    ct: function(text, cx, partials) {
      if (this.options.disableLambda) {
        throw new Error('Lambda features disabled.');
      }
      return this.c.compile(text, this.options).render(cx, partials);
    },

    // template result buffering
    b: function(s) { this.buf += s; },

    fl: function() { var r = this.buf; this.buf = ''; return r; },

    // method replace section
    ms: function(func, ctx, partials, inverted, start, end, tags) {
      var textSource,
          cx = ctx[ctx.length - 1],
          result = func.call(cx);

      if (typeof result == 'function') {
        if (inverted) {
          return true;
        } else {
          textSource = (this.activeSub && this.subsText && this.subsText[this.activeSub]) ? this.subsText[this.activeSub] : this.text;
          return this.ls(result, cx, partials, textSource.substring(start, end), tags);
        }
      }

      return result;
    },

    // method replace variable
    mv: function(func, ctx, partials) {
      var cx = ctx[ctx.length - 1];
      var result = func.call(cx);

      if (typeof result == 'function') {
        return this.ct(coerceToString(result.call(cx)), cx, partials);
      }

      return result;
    },

    sub: function(name, context, partials, indent) {
      var f = this.subs[name];
      if (f) {
        this.activeSub = name;
        f(context, partials, this, indent);
        this.activeSub = false;
      }
    }

  };

  //Find a key in an object
  function findInScope(key, scope, doModelGet) {
    var val;

    if (scope && typeof scope == 'object') {

      if (scope[key] !== undefined) {
        val = scope[key];

      // try lookup with get for backbone or similar model data
      } else if (doModelGet && scope.get && typeof scope.get == 'function') {
        val = scope.get(key);
      }
    }

    return val;
  }

  function createSpecializedPartial(instance, subs, partials, stackSubs, stackPartials, stackText) {
    function PartialTemplate() {};
    PartialTemplate.prototype = instance;
    function Substitutions() {};
    Substitutions.prototype = instance.subs;
    var key;
    var partial = new PartialTemplate();
    partial.subs = new Substitutions();
    partial.subsText = {};  //hehe. substext.
    partial.buf = '';

    stackSubs = stackSubs || {};
    partial.stackSubs = stackSubs;
    partial.subsText = stackText;
    for (key in subs) {
      if (!stackSubs[key]) stackSubs[key] = subs[key];
    }
    for (key in stackSubs) {
      partial.subs[key] = stackSubs[key];
    }

    stackPartials = stackPartials || {};
    partial.stackPartials = stackPartials;
    for (key in partials) {
      if (!stackPartials[key]) stackPartials[key] = partials[key];
    }
    for (key in stackPartials) {
      partial.partials[key] = stackPartials[key];
    }

    return partial;
  }

  var rAmp = /&/g,
      rLt = /</g,
      rGt = />/g,
      rApos = /\'/g,
      rQuot = /\"/g,
      hChars = /[&<>\"\']/;

  function coerceToString(val) {
    return String((val === null || val === undefined) ? '' : val);
  }

  function hoganEscape(str) {
    str = coerceToString(str);
    return hChars.test(str) ?
      str
        .replace(rAmp, '&amp;')
        .replace(rLt, '&lt;')
        .replace(rGt, '&gt;')
        .replace(rApos, '&#39;')
        .replace(rQuot, '&quot;') :
      str;
  }

  var isArray = Array.isArray || function(a) {
    return Object.prototype.toString.call(a) === '[object Array]';
  };

})(typeof exports !== 'undefined' ? exports : Hogan);

},{}],13:[function(require,module,exports){
var CountdownTimerView, FourPackCarouselView, FullWidthCarousel, GoodsCarouselView, ResponsiveCarouselView, RightRailView, VideoWidgetView, base,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

FourPackCarouselView = (function(superClass) {
  extend(FourPackCarouselView, superClass);

  function FourPackCarouselView() {
    return FourPackCarouselView.__super__.constructor.apply(this, arguments);
  }

  FourPackCarouselView.prototype.events = {
    'click .carousel-previous': 'moveLeft',
    'click .carousel-next': 'moveRight'
  };

  FourPackCarouselView.prototype.initialize = function() {
    this.$carousel = this.$('.carousel');
    this.$leftButton = this.$('.carousel-previous');
    this.$rightButton = this.$('.carousel-next');
    this.$pagesList = this.$('.carousel-pages');
    this.currentPosition = 0;
    this.currentPage = 1;
    this.maxPosition = this.$('.deal-card').length - 1;
    this.visibleCards = 4;
    this._buildNavigation();
    return this._lazyLoadAllImages();
  };

  FourPackCarouselView.prototype._buildNavigation = function() {
    var i, lastPage, page, ref;
    lastPage = Math.ceil((this.maxPosition + 1) / this.visibleCards);
    for (page = i = 1, ref = lastPage; 1 <= ref ? i <= ref : i >= ref; page = 1 <= ref ? ++i : --i) {
      this.$pagesList.append("<li class='page-count page-" + page + "'></li>");
    }
    return this.$('.page-1').addClass('active');
  };

  FourPackCarouselView.prototype._lazyLoadAllImages = function() {
    return this.$('.lazy-load').lazyload({
      container: this.$carousel,
      threshold: this.$carousel.width()
    });
  };

  FourPackCarouselView.prototype.moveLeft = function() {
    if (!this.canMoveLeft()) {
      return;
    }
    if (this.$leftButton.hasClass('inactive')) {
      return;
    }
    this.currentPage -= 1;
    if (this.currentPosition - this.visibleCards < 0) {
      return this.animate(0);
    } else {
      return this.animate(this.currentPosition - this.visibleCards);
    }
  };

  FourPackCarouselView.prototype.moveRight = function() {
    if (!this.canMoveRight()) {
      return;
    }
    if (this.$rightButton.hasClass('inactive')) {
      return;
    }
    this.currentPage += 1;
    if (this.currentPosition + (this.visibleCards - 1) + this.visibleCards > this.maxPosition) {
      return this.animate(this.maxPosition - (this.visibleCards - 1));
    } else {
      return this.animate(this.currentPosition + this.visibleCards);
    }
  };

  FourPackCarouselView.prototype.canMoveRight = function() {
    return (this.currentPosition + this.visibleCards) <= this.maxPosition;
  };

  FourPackCarouselView.prototype.canMoveLeft = function() {
    return this.currentPosition >= 1;
  };

  FourPackCarouselView.prototype.showButton = function($button) {
    return $button.removeClass('inactive');
  };

  FourPackCarouselView.prototype.hideButton = function($button) {
    return $button.addClass('inactive');
  };

  FourPackCarouselView.prototype.animate = function(newPosition) {
    if (Modernizr.csstransitions) {
      this.$carousel.css({
        left: -(newPosition * 239)
      });
      return this.finishAnimation(newPosition);
    } else {
      return this.$carousel.animate({
        left: -(newPosition * 239)
      }, {
        duration: 250,
        complete: (function(_this) {
          return function() {
            return _this.finishAnimation(newPosition);
          };
        })(this)
      });
    }
  };

  FourPackCarouselView.prototype.finishAnimation = function(newPosition) {
    this.currentPosition = newPosition;
    this.$('.page-count').removeClass('active');
    this.$(".page-" + this.currentPage).addClass('active');
    if (this.canMoveLeft()) {
      this.showButton(this.$leftButton);
    } else {
      this.hideButton(this.$leftButton);
    }
    if (this.canMoveRight()) {
      return this.showButton(this.$rightButton);
    } else {
      return this.hideButton(this.$rightButton);
    }
  };

  return FourPackCarouselView;

})(Backbone.View);

RightRailView = (function(superClass) {
  extend(RightRailView, superClass);

  function RightRailView() {
    this.setFixPoint = bind(this.setFixPoint, this);
    this.shouldFix = bind(this.shouldFix, this);
    this.atBottom = bind(this.atBottom, this);
    this.floatView = bind(this.floatView, this);
    return RightRailView.__super__.constructor.apply(this, arguments);
  }

  RightRailView.prototype.initialize = function() {
    this.container = $(window);
    this.document = $(document);
    this.header = $(".header");
    this.banner = $(".in-app-msg-banner");
    this.bannerCloseBtn = $(".in-app-msg-banner .hide-link");
    this.footer = $(".footer-i18n");
    this.fixedTopMargin = 50;
    this.fixPoint = 0;
    this.setFixPoint();
    this.floatView();
    this.container.scroll(this.floatView);
    return this.bannerCloseBtn.click(this.setFixPoint);
  };

  RightRailView.prototype.floatView = function() {
    this.$el.removeClass('fixed top bottom');
    if (this.shouldFix()) {
      return this.$el.addClass('fixed');
    } else if (this.atBottom()) {
      return this.$el.addClass('bottom');
    } else {
      return this.$el.addClass('top');
    }
  };

  RightRailView.prototype.atBottom = function() {
    return this.container.scrollTop() + this.$el.outerHeight() + this.fixedTopMargin > this.document.height() - this.footer.outerHeight();
  };

  RightRailView.prototype.shouldFix = function() {
    return this.container.scrollTop() > this.fixPoint && !this.atBottom();
  };

  RightRailView.prototype.setFixPoint = function() {
    return this.fixPoint = this.header.position().top + this.outerHeightWithMargin(this.header) + this.outerHeightWithMargin(this.banner) - this.fixedTopMargin;
  };

  RightRailView.prototype.outerHeightWithMargin = function(element) {
    if (!element.is(':visible')) {
      return 0;
    }
    return element.outerHeight(true);
  };

  return RightRailView;

})(Backbone.View);

VideoWidgetView = (function(superClass) {
  extend(VideoWidgetView, superClass);

  function VideoWidgetView() {
    this.resetVideoPlayer = bind(this.resetVideoPlayer, this);
    this.onCreate = bind(this.onCreate, this);
    return VideoWidgetView.__super__.constructor.apply(this, arguments);
  }

  VideoWidgetView.prototype.events = {
    'click .image-container': 'playVideo'
  };

  VideoWidgetView.videoIsloaded = false;

  VideoWidgetView.prototype.initialize = function() {
    if (this.$el == null) {
      this.$el = $(this.el);
    }
    this.video = this.$('.video-container');
    this.imageContainer = this.$('.image-container');
    this.previewImageAndPlayButton = this.$('.image-container img');
    this.videoId = this.video.data('video-id');
    if (!this.videoIsloaded) {
      return this.loadVideoPlayer();
    }
  };

  VideoWidgetView.prototype.onCreate = function(player) {
    return player.subscribe('played', 'myPage', this.resetVideoPlayer);
  };

  VideoWidgetView.prototype.resetVideoPlayer = function() {
    this.imageContainer.removeClass('hidden');
    this.previewImageAndPlayButton.animate({
      opacity: 0.8,
      duration: 100
    });
    return this.videoPlayer.seek(0);
  };

  VideoWidgetView.prototype.fetchVideoPlayer = function() {
    return OO.ready((function(_this) {
      return function() {
        var options;
        options = {
          flashParams: {
            hide: 'info,endscreen'
          },
          onCreate: _this.onCreate
        };
        return _this.videoPlayer = OO.Player.create('ooyala-player', _this.videoId, options);
      };
    })(this));
  };

  VideoWidgetView.prototype.loadVideoPlayer = function() {
    var script;
    script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "//player.ooyala.com/v3/4e60e82cdbc14def8b05623206f02388";
    if (script.readyState) {
      script.onreadystatechange = function() {
        if (script.readyState === "loaded" || script.readyState === "complete") {
          this.videoIsloaded = true;
        }
      };
    } else {
      script.onload = function() {
        this.videoIsloaded = true;
      };
    }
    $("head").append(script);
  };

  VideoWidgetView.prototype.playVideo = function() {
    if (!this.videoPlayer) {
      this.fetchVideoPlayer();
    }
    this.videoPlayer.play();
    this.imageContainer.addClass('hidden');
    return this.previewImageAndPlayButton.css({
      opacity: 0
    });
  };

  return VideoWidgetView;

})(Backbone.View);

CountdownTimerView = (function(superClass) {
  extend(CountdownTimerView, superClass);

  function CountdownTimerView() {
    this.getNewTimeStamp = bind(this.getNewTimeStamp, this);
    this.updateCountdown = bind(this.updateCountdown, this);
    return CountdownTimerView.__super__.constructor.apply(this, arguments);
  }

  CountdownTimerView.prototype.initialize = function() {
    if (this.$el == null) {
      this.$el = $(this.el);
    }
    this.offerEndTime = $('.steals-timer').data('offer-end-time');
    this.tick = 1000;
    this.getNewTimeStamp();
    return this.updateCountdown();
  };

  CountdownTimerView.prototype.updateCountdown = function() {
    return setInterval(this.getNewTimeStamp, this.tick);
  };

  CountdownTimerView.prototype.timeRemaining = function(timeRemainingMilliseconds) {
    var days, hours, millisecondsLeft, minutes, seconds;
    if (timeRemainingMilliseconds == null) {
      return {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      };
    }
    days = Math.floor(timeRemainingMilliseconds / (1000 * 3600 * 24));
    millisecondsLeft = Math.floor(timeRemainingMilliseconds - days * (1000 * 3600 * 24));
    hours = Math.floor(millisecondsLeft / (1000 * 3600));
    millisecondsLeft = Math.floor(millisecondsLeft - hours * (1000 * 3600));
    minutes = Math.floor(millisecondsLeft / (1000 * 60));
    millisecondsLeft = Math.floor(millisecondsLeft - minutes * 1000 * 60);
    seconds = Math.floor(millisecondsLeft / 1000);
    return {
      days: days,
      hours: hours,
      minutes: minutes,
      seconds: seconds
    };
  };

  CountdownTimerView.prototype.millisRemaining = function(endTime) {
    var millsRemaining, rightNow;
    if (endTime == null) {
      return 0;
    }
    rightNow = new Date().getTime();
    millsRemaining = endTime - rightNow;
    if (millsRemaining < 0) {
      return 0;
    } else {
      return millsRemaining;
    }
  };

  CountdownTimerView.prototype.countdownTimestamp = function(timeLeft) {
    var hh, mm, ss;
    hh = this.addLeadingZero(timeLeft.hours);
    mm = this.addLeadingZero(timeLeft.minutes);
    ss = this.addLeadingZero(timeLeft.seconds);
    return " " + hh + ":" + mm + ":" + ss;
  };

  CountdownTimerView.prototype.addLeadingZero = function(number) {
    if (number < 0) {
      return;
    }
    if (number < 10) {
      return "0" + number;
    } else {
      return "" + number;
    }
  };

  CountdownTimerView.prototype.getNewTimeStamp = function() {
    var endTime, millisLeft, newTimeStamp, ref;
    if (((ref = this.offerEndTime) != null ? ref.length : void 0) < 1) {
      this.offerEndTime = this.getEndOfDayTime();
    }
    endTime = Date.parse(this.offerEndTime);
    millisLeft = this.millisRemaining(endTime);
    newTimeStamp = this.countdownTimestamp(this.timeRemaining(millisLeft));
    return this.$el.html(newTimeStamp);
  };

  CountdownTimerView.prototype.getEndOfDayTime = function() {
    var date;
    date = new Date();
    date.setDate(date.getDate() + 1);
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    return date;
  };

  return CountdownTimerView;

})(Backbone.View);

GoodsCarouselView = (function(superClass) {
  extend(GoodsCarouselView, superClass);

  function GoodsCarouselView() {
    this.start = bind(this.start, this);
    return GoodsCarouselView.__super__.constructor.apply(this, arguments);
  }

  GoodsCarouselView.prototype.events = {
    "click .goods-carousel-navbar .icon-arrow-left-large": "slideLeft",
    "click .goods-carousel-navbar .icon-arrow-right-large": "slideRight",
    "click .goods-carousel-navbar .icon-circle": "navigateToNavItem"
  };

  GoodsCarouselView.prototype.initialize = function() {
    this.interval = 6000;
    this.size = this.$(".carousel-slide").length;
    this.fadeDuration = 20;
    if (this.size > 1) {
      this.position = 1;
      this.$slides = this.$('.carousel-slide');
      this.$navs = this.$('.goods-carousel-navbar .icon-circle');
      return setTimeout(this.start, this.interval);
    }
  };

  GoodsCarouselView.prototype.slideLeft = function() {
    this.stop();
    return this.slide('left');
  };

  GoodsCarouselView.prototype.slideRight = function() {
    this.stop();
    return this.slide();
  };

  GoodsCarouselView.prototype.navigateToNavItem = function(e) {
    var position;
    position = $(e.currentTarget).data('position');
    this.stop();
    return this.updateCarousel(position);
  };

  GoodsCarouselView.prototype.start = function() {
    this.slide();
    return this.slider = setTimeout(this.start, this.interval);
  };

  GoodsCarouselView.prototype.stop = function() {
    return window.clearTimeout(this.slider);
  };

  GoodsCarouselView.prototype.slide = function(direction) {
    if (direction == null) {
      direction = 'right';
    }
    return this.updateCarousel(this.nextPosition(direction));
  };

  GoodsCarouselView.prototype.nextPosition = function(direction) {
    if (direction === 'right') {
      if (this.position < this.size) {
        return this.position + 1;
      } else {
        return 1;
      }
    } else {
      if (this.position > 1) {
        return this.position - 1;
      } else {
        return this.size;
      }
    }
  };

  GoodsCarouselView.prototype.updateCarousel = function(nextPosition) {
    if (this.position === nextPosition) {
      return;
    }
    this.updateSlide(nextPosition);
    this.updateNav(nextPosition);
    return this.position = nextPosition;
  };

  GoodsCarouselView.prototype.updateSlide = function(nextPosition) {
    var currentSlide, nextSlide;
    currentSlide = this.$slides.filter('.current-slide');
    nextSlide = this.$slides.filter("[data-position='" + nextPosition + "']");
    currentSlide.fadeTo(this.fadeDuration, 0);
    currentSlide.hide().removeClass("current-slide");
    return nextSlide.show().fadeTo(this.fadeDuration, 1).addClass("current-slide");
  };

  GoodsCarouselView.prototype.updateNav = function(nextPosition) {
    var currentNav, nextNav;
    currentNav = this.$navs.filter('.current-slide');
    nextNav = this.$navs.filter("[data-position='" + nextPosition + "']");
    currentNav.removeClass("current-slide");
    return nextNav.addClass("current-slide");
  };

  return GoodsCarouselView;

})(Backbone.View);

FullWidthCarousel = (function(superClass) {
  extend(FullWidthCarousel, superClass);

  function FullWidthCarousel() {
    this._setGutters = bind(this._setGutters, this);
    return FullWidthCarousel.__super__.constructor.apply(this, arguments);
  }

  FullWidthCarousel.prototype.events = {
    'click .full-width-carousel-prev': 'triggerPrev',
    'click .full-width-carousel-next': 'triggerNext',
    'click .full-width-carousel-dot': 'triggerNavDot'
  };

  FullWidthCarousel.prototype.initialize = function() {
    this.$listbox = this.$el.find('[role=listbox]');
    this.pixelsToMove = this._pixelsToMove();
    this.centeredViewportLeft = this.$listbox.css('left');
    this._initalizeGutters();
    this._animationDuration = 200;
    this._numberNavDots = this.$el.find('.full-width-carousel-dot').length;
    this._lazyLoadAllImages();
    return this._updateSelectedDeals();
  };

  FullWidthCarousel.prototype._lazyLoadAllImages = function() {
    var container;
    container = this.$('.full-width-carousel-container');
    return this.$('.lazy-load').lazyload({
      container: container,
      threshold: this.$listbox.width()
    });
  };

  FullWidthCarousel.prototype.triggerNavDot = function(event) {
    var newPosition, oldPosition;
    event.preventDefault();
    newPosition = $(event.currentTarget).data('index');
    oldPosition = this.$el.find('.full-width-carousel-dot-selected').data('index');
    this._updateNavDotSelected(newPosition);
    switch (false) {
      case !(oldPosition < newPosition):
        return this._moveRight(newPosition - oldPosition);
      case !(newPosition < oldPosition):
        return this._moveLeft(oldPosition - newPosition);
    }
  };

  FullWidthCarousel.prototype.triggerNext = function(event) {
    var currentSelected, newPosition;
    event.preventDefault();
    currentSelected = this.$el.find('.full-width-carousel-dot-selected').data('index');
    newPosition = this._wrapPosition(currentSelected + 1);
    this._updateNavDotSelected(newPosition);
    return this._moveRight();
  };

  FullWidthCarousel.prototype.triggerPrev = function(event) {
    var currentSelected, newPosition;
    event.preventDefault();
    currentSelected = this.$el.find('.full-width-carousel-dot-selected').data('index');
    newPosition = this._wrapPosition(currentSelected - 1);
    this._updateNavDotSelected(newPosition);
    return this._moveLeft();
  };

  FullWidthCarousel.prototype._initalizeGutters = function() {
    var throttledGutters;
    throttledGutters = _.throttle(this._setGutters, 300);
    throttledGutters();
    return $(window).on("resize", throttledGutters);
  };

  FullWidthCarousel.prototype._setGutters = function() {
    return $(".full-width-carousel-viewport").css("left", this._gutterWidth());
  };

  FullWidthCarousel.prototype._gutterWidth = function() {
    var carouselViewport, carouselViewportWidth, windowWidth;
    windowWidth = $(window).width();
    carouselViewport = this.$el.find(".full-width-carousel-viewport");
    carouselViewportWidth = carouselViewport.width();
    return (windowWidth - carouselViewportWidth) / 2;
  };

  FullWidthCarousel.prototype._wrapPosition = function(index) {
    return (index + this._numberNavDots) % this._numberNavDots;
  };

  FullWidthCarousel.prototype._moveRight = function(numberOfMoves) {
    var $images, nextAnimation;
    if (numberOfMoves == null) {
      numberOfMoves = 1;
    }
    $images = this.$listbox.find(".full-width-carousel-item").slice(0, 3);
    this.$listbox.append($images);
    this.$listbox.css('left', -960);
    if (numberOfMoves > 1) {
      nextAnimation = (function(_this) {
        return function() {
          return _this._moveRight(numberOfMoves - 1);
        };
      })(this);
    }
    return this._transition(-this.pixelsToMove, nextAnimation);
  };

  FullWidthCarousel.prototype._moveLeft = function(numberOfMoves) {
    var $images, nextAnimation;
    if (numberOfMoves == null) {
      numberOfMoves = 1;
    }
    $images = this.$listbox.find(".full-width-carousel-item").slice(-3);
    this.$listbox.prepend($images);
    this.$listbox.css('left', -(960 * 3));
    if (numberOfMoves > 1) {
      nextAnimation = (function(_this) {
        return function() {
          return _this._moveLeft(numberOfMoves - 1);
        };
      })(this);
    }
    return this._transition(this.pixelsToMove, nextAnimation);
  };

  FullWidthCarousel.prototype._transition = function(movePixels, nextAnimation) {
    var completionCallback;
    completionCallback = (function(_this) {
      return function() {
        if (nextAnimation) {
          nextAnimation();
        }
        return _this._updateSelectedDeals();
      };
    })(this);
    return this.$listbox.stop().animate({
      left: "+=" + movePixels
    }, {
      easing: 'linear',
      duration: this._animationDuration,
      complete: completionCallback
    });
  };

  FullWidthCarousel.prototype._updateSelectedDeals = function() {
    var items;
    items = this.$listbox.find('.full-width-carousel-item');
    items.removeClass('full-width-carousel-item-selected');
    return items.slice(6, 9).addClass('full-width-carousel-item-selected');
  };

  FullWidthCarousel.prototype._pixelsToMove = function() {
    var activeItems, fullWidthItemFinalWidth, includeMargin;
    activeItems = 3;
    includeMargin = true;
    fullWidthItemFinalWidth = $(".full-width-carousel-item").first().outerWidth(includeMargin);
    return fullWidthItemFinalWidth * activeItems;
  };

  FullWidthCarousel.prototype._updateNavDotSelected = function(indexToSelect) {
    this.$el.find('.full-width-carousel-dot').removeClass('full-width-carousel-dot-selected');
    return this.$el.find(".full-width-carousel-dot[data-index=" + indexToSelect + "]").addClass('full-width-carousel-dot-selected');
  };

  return FullWidthCarousel;

})(Backbone.View);

ResponsiveCarouselView = (function(superClass) {
  extend(ResponsiveCarouselView, superClass);

  function ResponsiveCarouselView() {
    this.recalculate = bind(this.recalculate, this);
    return ResponsiveCarouselView.__super__.constructor.apply(this, arguments);
  }

  ResponsiveCarouselView.prototype.events = {
    'click .carousel-previous': 'moveLeft',
    'click .carousel-next': 'moveRight'
  };

  ResponsiveCarouselView.prototype.initialize = function() {
    this.$carousel = this.$('.carousel');
    this.$leftButton = this.$('.carousel-previous');
    this.$rightButton = this.$('.carousel-next');
    this.$pagesList = this.$('.carousel-pages');
    this.$header = this.$('.section-head');
    this.containerWidth = this.$el.outerWidth();
    this.currentPosition = 0;
    this.currentPage = 0;
    this.maxPosition = this.$('.deal-card').length - 1;
    this.gap = 70;
    this.cardSize = 240;
    this.mainContentWidth = 960;
    this.visibleCards = Math.floor((this.containerWidth - this.gap) / this.cardSize);
    this.rightPixelsRemainder = (this.containerWidth - this.gap) % this.cardSize;
    $(window).resize(this, this.recalculate);
    this._alignTitle();
    this._buildNavigation();
    return this._lazyLoadAllImages();
  };

  ResponsiveCarouselView.prototype._buildNavigation = function() {
    var i, page, ref;
    this.lastPage = Math.ceil((this.maxPosition + 1) / this.visibleCards) - 1;
    for (page = i = 0, ref = this.lastPage; 0 <= ref ? i <= ref : i >= ref; page = 0 <= ref ? ++i : --i) {
      this.$pagesList.append("<li class='page-count page-" + page + "' data-page='" + page + "' data-bhc='control:circle" + page + "'></li>");
    }
    $('.page-count').on('click', (function(_this) {
      return function(e) {
        _this.currentPage = $(e.currentTarget).data('page');
        if (_this.currentPage === _this.lastPage) {
          return _this.animateLastRight(_this.maxPosition - (_this.visibleCards - 1));
        } else {
          return _this.animate(_this.currentPage * _this.visibleCards);
        }
      };
    })(this));
    return this._calculateCurrentPage();
  };

  ResponsiveCarouselView.prototype._calculateCurrentPage = function() {
    this.currentPage = Math.floor(this.currentPosition / this.visibleCards);
    this.$('.page-count').removeClass('active');
    this.$(".page-" + this.currentPage).addClass('active');
    if (this.currentPage === this.lastPage) {
      return this.animateLastRight(this.maxPosition - (this.visibleCards - 1));
    }
  };

  ResponsiveCarouselView.prototype._lazyLoadAllImages = function() {
    return this.$('.lazy-load').lazyload({
      container: this.$carousel,
      threshold: this.$carousel.width()
    });
  };

  ResponsiveCarouselView.prototype._alignTitle = function() {
    if (this.containerWidth > this.mainContentWidth) {
      return this.$header.css({
        'margin-left': Math.floor((this.containerWidth - this.mainContentWidth) / 2)
      });
    }
  };

  ResponsiveCarouselView.prototype.recalculate = function() {
    this.containerWidth = this.$el.outerWidth();
    this.visibleCards = Math.floor((this.containerWidth - this.gap) / this.cardSize);
    this.rightPixelsRemainder = (this.containerWidth - this.gap) % this.cardSize;
    this._alignTitle();
    this.$pagesList.empty();
    return this._buildNavigation();
  };

  ResponsiveCarouselView.prototype.moveLeft = function() {
    if (!this.canMoveLeft()) {
      return;
    }
    if (this.$leftButton.hasClass('inactive')) {
      return;
    }
    if (this.currentPage > 0) {
      this.currentPage -= 1;
    }
    if (this.currentPosition - this.visibleCards < 0) {
      return this.animate(0);
    } else {
      return this.animate(this.currentPosition - this.visibleCards);
    }
  };

  ResponsiveCarouselView.prototype.moveRight = function() {
    if (!this.canMoveRight()) {
      return;
    }
    if (this.$rightButton.hasClass('inactive')) {
      return;
    }
    if (this.currentPage < this.lastPage) {
      this.currentPage += 1;
    }
    if (this.currentPosition + (this.visibleCards - 1) + this.visibleCards >= this.maxPosition) {
      return this.animateLastRight(this.maxPosition - (this.visibleCards - 1));
    } else {
      return this.animate(this.currentPosition + this.visibleCards);
    }
  };

  ResponsiveCarouselView.prototype.canMoveRight = function() {
    return (this.currentPosition + this.visibleCards) <= this.maxPosition;
  };

  ResponsiveCarouselView.prototype.canMoveLeft = function() {
    return this.currentPosition >= 1;
  };

  ResponsiveCarouselView.prototype.showButton = function($button) {
    return $button.removeClass('inactive');
  };

  ResponsiveCarouselView.prototype.hideButton = function($button) {
    return $button.addClass('inactive');
  };

  ResponsiveCarouselView.prototype.animate = function(newPosition) {
    if (Modernizr.csstransitions) {
      this.$carousel.css({
        left: -(newPosition * this.cardSize) + this.gap
      });
      return this.finishAnimation(newPosition);
    } else {
      return this.$carousel.animate({
        left: -(newPosition * this.cardSize) + this.gap
      }, {
        duration: 250,
        complete: (function(_this) {
          return function() {
            return _this.finishAnimation(newPosition);
          };
        })(this)
      });
    }
  };

  ResponsiveCarouselView.prototype.animateLastRight = function(newPosition) {
    if (Modernizr.csstransitions) {
      this.$carousel.css({
        left: -(newPosition * this.cardSize) + this.rightPixelsRemainder
      });
      return this.finishAnimation(newPosition);
    } else {
      return this.$carousel.animate({
        left: -(newPosition * this.cardSize) + this.rightPixelsRemainder
      }, {
        duration: 250,
        complete: (function(_this) {
          return function() {
            return _this.finishAnimation(newPosition);
          };
        })(this)
      });
    }
  };

  ResponsiveCarouselView.prototype.finishAnimation = function(newPosition) {
    this.currentPosition = newPosition;
    this.$('.page-count').removeClass('active');
    this.$(".page-" + this.currentPage).addClass('active');
    if (this.canMoveLeft()) {
      this.showButton(this.$leftButton);
    } else {
      this.hideButton(this.$leftButton);
    }
    if (this.canMoveRight()) {
      return this.showButton(this.$rightButton);
    } else {
      return this.hideButton(this.$rightButton);
    }
  };

  return ResponsiveCarouselView;

})(Backbone.View);

if (window.WLS == null) {
  window.WLS = {};
}

if ((base = window.WLS).Views == null) {
  base.Views = {};
}

window.WLS.Views.FourPackCarousel = FourPackCarouselView;

window.WLS.Views.RightRail = RightRailView;

window.WLS.Views.VideoWidget = VideoWidgetView;

window.WLS.Views.CountdownTimer = CountdownTimerView;

window.WLS.Views.GoodsCarouselView = GoodsCarouselView;

window.WLS.Views.FullWidthCarousel = FullWidthCarousel;

window.WLS.Views.ResponsiveCarousel = ResponsiveCarouselView;

WLS.init = function($el) {
  if ($el == null) {
    $el = $(document.body);
  }
  $el.find('.right-rail').each(function(index, el) {
    return new WLS.Views.RightRail({
      el: el
    });
  });
  $el.find('.carousel-widget').each(function(index, el) {
    return new WLS.Views.FourPackCarousel({
      el: el
    });
  });
  $el.find('.video-widget').each(function(index, el) {
    return new WLS.Views.VideoWidget({
      el: el
    });
  });
  $el.find('.steals-timer').each(function(index, el) {
    return new WLS.Views.CountdownTimer({
      el: el
    });
  });
  $el.find('.goods-carousel').each(function(index, el) {
    return new WLS.Views.GoodsCarouselView({
      el: el
    });
  });
  $('.full-width-carousel').each(function(index, el) {
    return new WLS.Views.FullWidthCarousel({
      el: el
    });
  });
  return $el.find('.responsive-carousel-widget').each(function(index, el) {
    return new WLS.Views.ResponsiveCarousel({
      el: el
    });
  });
};

$(window).load(function() {
  return WLS.init();
});



},{}]},{},[1])

